import fvSubassembly from "../fvSubassembly"
export default class fvPowerSwitch extends fvSubassembly{
    constructor(sContent,parent,system,callback){
        super(sContent,parent,system);
        this.create();
        this.value = -1;
        if(this.dbVar.length != 0 && this.dbVar[0] != ""){
            var tag = this.dbVar[0];
            tag = tag ? tag.replace(".PV", "") : undefined;

            this.getValue = new AsyncFunction("return " +"__dbTags."+tag.replace(/\\/g,"."));
        }
        
        if(this.isDelayedWaiting){
            this.complete = callback;
        }else{
            callback(this);
        }
        this.createSucss();
        
        
    }
    /*
        功能:服务端实时数据返回通知接口
        参数:无
        返回值:无
    */
    async onUpdata(){
        if(this.dbVar.length != 0 && this.dbVar[0] != ""){
            var getTag = await this.getValue();
            this.value = getTag.PV;
        }
    }

    onDraw(canvas){
        if(!this.fcHide) return;
        if(typeof this[this.switchType] == "function"){
            this[this.switchType](canvas,this.value);
        }
        
    }

    drawLine(canvas,originalx,originaly,goalx,goaly){
        canvas.moveTo(originalx,originaly);
        canvas.lineTo(goalx,goaly);
    }
    //绘制箭头
    drawArrow(ctx,fromX,fromY,toX,toY,theta,headlen,width,color,type){
        var theta = theta || 30,
            headlen = headlen || 10,
            width = width || 1,
            color = color || '#000',
            angle = Math.atan2(fromY - toY, fromX - toX) * 180 / Math.PI,
            angle1 = (angle + theta) * Math.PI / 180,
            angle2 = (angle - theta) * Math.PI / 180,
            topX = headlen * Math.cos(angle1),
            topY = headlen * Math.sin(angle1),
            botX = headlen * Math.cos(angle2),
            botY = headlen * Math.sin(angle2);
        ctx.save();
        ctx.beginPath();
        var arrowX, arrowY;
        ctx.moveTo(fromX, fromY);
        ctx.lineTo(toX, toY);
        arrowX = toX + topX;
        arrowY = toY + topY;
        ctx.moveTo(arrowX, arrowY);
        ctx.lineTo(toX, toY);
        arrowX = toX + botX;
        arrowY = toY + botY;
        ctx.lineTo(arrowX, arrowY);

        ctx.strokeStyle = color;
        ctx.lineWidth = width;
        ctx[type]()
        ctx.restore();
    }
    draw1000(canvas){
        canvas.save();
        canvas.translate(this.cx+this.width/2,this.cy+this.height/2);
        canvas.rotate((Math.PI/180)*this.rotate);
        canvas.translate(-(this.cx+this.width/2),-(this.cy+this.height/2));
       
       
        canvas.beginPath();
        this.drawLine(canvas,this.cx+this.width/2,this.cy,this.cx+this.width/2,this.cy+this.height);
        canvas.lineWidth=this.lineWight;
        canvas.strokeStyle=this.lineColer;
        canvas.stroke();
        canvas.beginPath();
        canvas.rect(this.cx+this.width/4,this.cy+this.height/4,this.width/2,this.height/2);
           
        if(this.value > 0){
            canvas.fillStyle=this.switchColor[0];
            canvas.fill()
            canvas.strokeStyle=this.switchColor[0];
        }else{
            canvas.fillStyle=this.switchColor[1];
            canvas.fill()
            canvas.strokeStyle=this.switchColor[1];
        }
        canvas.stroke();
        canvas.restore();
    }

    draw1001(canvas){
        canvas.save();
        canvas.translate(this.cx+this.width/2,this.cy+this.height/2);
        canvas.rotate((Math.PI/180)*this.rotate);
        canvas.translate(-(this.cx+this.width/2),-(this.cy+this.height/2));
      
        
        canvas.beginPath();
        this.drawLine(canvas,this.cx+this.width/2,this.cy,this.cx+this.width/2,this.cy+this.height/3);
        this.drawLine(canvas,this.cx+this.width/3,this.cy+this.height/3,this.cx+this.width*(2/3),this.cy+this.height/3);
        this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height,this.cx+this.width/2,this.cy+this.height*(2/3));
        canvas.lineWidth=this.lineWight;
        canvas.strokeStyle=this.lineColer;
        canvas.stroke();

        canvas.beginPath();
        if(this.value > 0){
            // this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height*(2/3),this.cx+this.width/2,this.cy+this.height/3);
            var x1 = this.cx+this.width/2 +(this.height/12)*Math.cos(180 * Math.PI/180);
            var y1 = this.cy+this.height*(5/12) +(this.height/12)*Math.sin(180 * Math.PI/180);
            this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height*(2/3),x1,y1);
            canvas.strokeStyle=this.switchColor[0];
        }else{
            var x1 = this.cx+this.width/2 +(this.height/3)*Math.cos(-120 * Math.PI/180);
            var y1 = this.cy+this.height*(2/3) +(this.height/3)*Math.sin(-120 * Math.PI/180);
            this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height*(2/3),x1,y1);
            canvas.strokeStyle=this.switchColor[1];
        }
        canvas.stroke();

        canvas.beginPath();
        canvas.arc(this.cx+this.width/2, this.cy+this.height*(5/12), this.height/12,0,2*Math.PI);
        canvas.restore();
        // canvas.closePath();
        canvas.stroke();
        canvas.restore();
    }
    draw1002(canvas){
        canvas.save();
        canvas.translate(this.cx+this.width/2,this.cy+this.height/2);
        canvas.rotate((Math.PI/180)*this.rotate);
        canvas.translate(-(this.cx+this.width/2),-(this.cy+this.height/2));
       
        
        canvas.beginPath();
        this.drawLine(canvas,this.cx+this.width/2,this.cy,this.cx+this.width/2,this.cy+this.height/6);
        this.drawLine(canvas,this.cx+this.width/4,this.cy+this.height/6,this.cx+this.width*(3/4),this.cy+this.height/6);
        this.drawLine(canvas,this.cx+this.width/3,this.cy+this.height,this.cx+this.width*(2/3),this.cy+this.height);
        this.drawLine(canvas,this.cx+this.width/4,this.cy+this.height*(11/12),this.cx+this.width*(3/4),this.cy+this.height*(11/12));
        this.drawLine(canvas,this.cx,this.cy+this.height*(5/6),this.cx+this.width,this.cy+this.height*(5/6));

        // this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height*(5/6),this.cx+this.width/2,this.cy+this.height/2);
        canvas.strokeStyle=this.lineColer;
        canvas.lineWidth=this.lineWight;
        canvas.stroke();

        canvas.beginPath();
        // this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height*(5/6),this.cx+this.width/2,this.cy+this.height/2);
        if(this.value > 0){
            canvas.strokeStyle=this.switchColor[0];
            canvas.moveTo(this.cx+this.width/2,this.cy+this.height*(5/6));
            canvas.lineTo(this.cx+this.width/2,this.cy+this.height/2);
            canvas.lineTo(this.cx+this.width/2,this.cy+this.height/6);
        }else{
            // x1 = x0 + r * cos(angle * PI / 180)
            // y1 = y0 + r * sin(angle * PI /180)
            canvas.strokeStyle=this.switchColor[1];
            var x1 = this.width/2 +(this.height/3)*Math.cos(-120 * Math.PI/180);
            var y1 = this.height/2 +(this.height/3)*Math.sin(-120 * Math.PI/180);
            canvas.moveTo(this.cx+this.width/2,this.cy+this.height*(5/6));
            canvas.lineTo(this.cx+this.width/2,this.cy+this.height/2);
            canvas.lineTo(this.cx+x1,this.cy+y1);
            
        }
        canvas.stroke();
        canvas.restore();
    }
    draw1003(canvas){
        canvas.save();
        canvas.translate(this.cx+this.width/2,this.cy+this.height/2);
        canvas.rotate((Math.PI/180)*this.rotate);
        canvas.translate(-(this.cx+this.width/2),-(this.cy+this.height/2));
        canvas.beginPath();
        this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height,this.cx+this.width/2,this.cy+this.height*(2/3));
        this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height/3,this.cx+this.width/2,this.cy);
        canvas.strokeStyle=this.lineColer;
        canvas.lineWidth=this.lineWight;
        canvas.stroke();
        canvas.beginPath();
        if(this.value > 0){
            this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height*(2/3),this.cx+this.width/2,this.cy+this.height/3);
            canvas.strokeStyle=this.switchColor[0];
        }else{
            var x1 = this.width/2 +(this.height/3)*Math.cos(-120 * Math.PI/180);
            var y1 = this.height*(2/3) +(this.height/3)*Math.sin(-120 * Math.PI/180);
            this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height*(2/3),this.cx+x1,this.cy+y1);
            canvas.strokeStyle=this.switchColor[1];
        }
        canvas.stroke(); 
        canvas.restore();
    }

    draw1004(canvas){
        canvas.save();
        canvas.translate(this.cx+this.width/2,this.cy+this.height/2);
        canvas.rotate((Math.PI/180)*this.rotate);
        canvas.translate(-(this.cx+this.width/2),-(this.cy+this.height/2));
        
  
        canvas.beginPath();
        this.drawLine(canvas,this.cx+this.width/3,this.cy,this.cx+this.width/3,this.cy+this.height/3);
        this.drawLine(canvas,this.cx+this.width*(2/3),this.cy,this.cx+this.width*(2/3),this.cy+this.height/3);
        this.drawLine(canvas,this.cx+this.width,this.cy,this.cx+this.width,this.cy+this.height/3);

        this.drawLine(canvas,this.cx+this.width/3,this.cy+this.height,this.cx+this.width/3,this.cy+this.height*(2/3));
        this.drawLine(canvas,this.cx+this.width*(2/3),this.cy+this.height,this.cx+this.width*(2/3),this.cy+this.height*(2/3));
        this.drawLine(canvas,this.cx+this.width,this.cy+this.height,this.cx+this.width,this.cy+this.height*(2/3));
        canvas.lineWidth=this.lineWight;
        canvas.strokeStyle=this.lineColer;
        canvas.stroke(); 
        if(this.value > 0){
            canvas.beginPath();
            this.drawLine(canvas,this.cx+this.width/3,this.cy+this.height*(2/3),this.cx+this.width/3,this.cy+this.height/3);
            this.drawLine(canvas,this.cx+this.width*(2/3),this.cy+this.height*(2/3),this.cx+this.width*(2/3),this.cy+this.height/3);
            this.drawLine(canvas,this.cx+this.width,this.cy+this.height*(2/3),this.cx+this.width,this.cy+this.height/3);

            this.drawLine(canvas,this.cx+this.width/3,this.cy+this.height/2,this.cx+this.width,this.cy+this.height/2);
            canvas.strokeStyle=this.switchColor[0];
            
        }else{
            canvas.beginPath();
            var x1 = this.cx+this.width/3 +(this.height/3)*Math.cos(-120 * Math.PI/180);
            var y1 = this.cy+this.height*(2/3) +(this.height/3)*Math.sin(-120 * Math.PI/180);

            var x2 = this.cx+this.width*(2/3) +(this.height/3)*Math.cos(-120 * Math.PI/180);
            var y2 = this.cy+this.height*(2/3) +(this.height/3)*Math.sin(-120 * Math.PI/180);

            var x3 = this.cx+this.width +(this.height/3)*Math.cos(-120 * Math.PI/180);
            var y3 = this.cy+this.height*(2/3) +(this.height/3)*Math.sin(-120 * Math.PI/180);

            var x4 = this.cx+this.width/3 +(this.height/6)*Math.cos(-120 * Math.PI/180);
            var y4 = this.cy+this.height*(2/3) +(this.height/6)*Math.sin(-120 * Math.PI/180);

            var x5 = this.cx+this.width +(this.height/6)*Math.cos(-120 * Math.PI/180);
            var y5 = this.cy+this.height*(2/3) +(this.height/6)*Math.sin(-120 * Math.PI/180);

            this.drawLine(canvas,this.cx+this.width/3,this.cy+this.height*(2/3),x1,y1);
            this.drawLine(canvas,this.cx+this.width*(2/3),this.cy+this.height*(2/3),x2,y2);
            this.drawLine(canvas,this.cx+this.width,this.cy+this.height*(2/3),x3,y3);

            this.drawLine(canvas,x4,y4,x5,y5);
            canvas.strokeStyle=this.switchColor[1];
            
        }
        canvas.stroke(); 
        canvas.restore();
    }
    
    draw1005(canvas){
        canvas.save();
        canvas.translate(this.cx+this.width/2,this.cy+this.height/2);
        canvas.rotate((Math.PI/180)*this.rotate);
        canvas.translate(-(this.cx+this.width/2),-(this.cy+this.height/2));
        
       
        canvas.beginPath();
        this.drawLine(canvas,this.cx+this.width/2,this.cy,this.cx+this.width/2,this.cy+this.height/3);
        this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height/24,this.cx+this.width,this.cy+this.height/24);
        this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height/12,this.cx,this.cy+this.height/12);
        this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height*(3/24),this.cx+this.width,this.cy+this.height*(3/24));
        this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height/6,this.cx,this.cy+this.height/6);
        this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height*(5/24),this.cx+this.width,this.cy+this.height*(5/24));
        this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height/4,this.cx,this.cy+this.height/4);
        this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height,this.cx+this.width/2,this.cy+this.height*(2/3));
        canvas.strokeStyle=this.lineColer;
        canvas.lineWidth=this.lineWight;
        canvas.stroke();

        canvas.beginPath();
        if(this.value>0){
            this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height*(2/3),this.cx+this.width/2,this.cy+this.height/3);
            canvas.strokeStyle=this.switchColor[0];
        }else{
            var x1 = this.width/2 +(this.height/3)*Math.cos(-120 * Math.PI/180);
            var y1 = this.height*(2/3) +(this.height/3)*Math.sin(-120 * Math.PI/180);
            this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height*(2/3),this.cx+x1,this.cy+y1);
            canvas.strokeStyle=this.switchColor[1];
        }
        canvas.stroke();
        canvas.restore();
    }
    draw1006(ctx){
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;
        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);
    
        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle=this.lineColer;
        this.drawLine(ctx,0,min/2,min/2,min/2);
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle=this.switchColor[0];
        this.drawLine(ctx,min/2,0,min/2,min);
        this.drawLine(ctx,min*0.7,min*0.8,min*0.7,min*0.2);
        this.drawLine(ctx,min*0.9,min*0.6,min*0.9,min*0.4);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw1007(ctx){
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;
        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);
    
        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle=this.lineColer;
        this.drawLine(ctx,0,min/2,min/2,min/2);
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle=this.switchColor[1];
        this.drawLine(ctx,min*0.5,0,min*0.5,min);
        this.drawLine(ctx,min*0.5,0,min,min*0.5);
        this.drawLine(ctx,min/2,min,min,min*0.5);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw1008(ctx){
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;
        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);
    
        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle=this.switchColor[0];
        ctx.arc(min*0.5,min*0.5,min*0.5,0,2*Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle=this.switchColor[1];
        this.drawLine(ctx,min*0.4,min*0.2,min*0.4,min*0.8);
        this.drawLine(ctx,min*0.6,min*0.2,min*0.6,min*0.8);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw1009(ctx){
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;
        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);
    
        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle=this.switchColor[0];
        this.drawLine(ctx,0,min/2,min*0.2,min*0.5);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min*0.5,min*0.5,min*0.3,1.5*Math.PI,Math.PI);
        this.drawLine(ctx,min*0.5,min*0.5,min,min*0.5);
        this.drawLine(ctx,min*0.5,min*0.2,min*0.5,min*0.5);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw1010(ctx){
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;
        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);
    
        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.strokeStyle=this.switchColor[0];
        ctx.beginPath();
        ctx.arc(min*0.5,min*0.5,min*0.3,0.6*Math.PI,0.4*Math.PI);
        this.drawLine(ctx,min*0.6,min*0.5,min*0.6,min*0.8);
        this.drawLine(ctx,min*0.6,min*0.5,min,min*0.5);
        this.drawLine(ctx,min*0.4,min*0.5,min*0.4,min*0.8);
        this.drawLine(ctx,min*0.4,min*0.5,0,min*0.5);
        this.drawLine(ctx,min*0.5,min*0.2,min*0.5,min*0.1);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw1011(ctx){
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;
        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);
    
        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.strokeStyle=this.switchColor[0];
        ctx.beginPath();
        ctx.arc(min*0.5,min*0.5,min*0.5,0,2*Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min*0.27,min*0.5,min*0.22,Math.PI,0);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min*0.71,min*0.5,min*0.22,0,Math.PI);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw1012(ctx){
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;
        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);
    
        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.strokeStyle=this.switchColor[0];
        ctx.beginPath();
        ctx.setLineDash([8, 8]);
        ctx.arc(min*0.5,min*0.5,min*0.5,0,2*Math.PI);
        ctx.stroke();
        ctx.setLineDash([]);
        ctx.beginPath();
        ctx.arc(min*0.27,min*0.5,min*0.22,Math.PI,0);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min*0.71,min*0.5,min*0.22,0,Math.PI);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw1013(ctx){
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;
        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);
    
        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.beginPath();
        ctx.lineWidth=this.lineWight;
        ctx.strokeStyle=this.lineColer;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];
        }
        ctx.fillRect(min*0.2,min*0.3,min*0.1,min*0.3);
        this.drawLine(ctx,min*0.25,min*0.3,min*0.25,min*0.1);
        this.drawLine(ctx,min*0.25,min*0.1,min*0.8,min*0.1);
        this.drawLine(ctx,min*0.25,min*0.6,min*0.25,min*0.8);
    
        this.drawLine(ctx,min*0.1,min*0.8,min*0.4,min*0.8);
        this.drawLine(ctx,min*0.15,min*0.85,min*0.35,min*0.85);
        this.drawLine(ctx,min*0.2,min*0.9,min*0.3,min*0.9);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw1014(ctx){
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;
        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);
    
        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.beginPath();
        ctx.lineWidth=this.lineWight;
        ctx.strokeStyle=this.lineColer;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];
        }
        
        ctx.fillRect(min*0.3,min*0.3,min*0.1,min*0.2);
        this.drawLine(ctx,min*0.35,min*0.3,min*0.35,0);
        this.drawLine(ctx,min*0.35,min*0.5,min*0.35,min*0.95);
        this.drawLine(ctx,min*0.35,min*0.75,min*0.6,min*0.75);
        this.drawLine(ctx,min*0.6,min*0.75,min*0.6,min*0.9);
    
        this.drawLine(ctx,min*0.29,min*0.1,min*0.41,min*0.1);
        this.drawLine(ctx,min*0.32,min*0.15,min*0.39,min*0.15);
    
        this.drawLine(ctx,min*0.29,min*0.6,min*0.41,min*0.6);
        this.drawLine(ctx,min*0.32,min*0.65,min*0.39,min*0.65);
    
        this.drawLine(ctx,min*0.5,min*0.9,min*0.7,min*0.9);
        this.drawLine(ctx,min*0.54,min*0.95,min*0.66,min*0.95);
        this.drawLine(ctx,min*0.57,min*0.99,min*0.64,min*0.99);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min*0.35,min*0.97,min*0.02,0,2*Math.PI);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw1015(ctx){
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;
        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);
    
        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.beginPath();
        ctx.lineWidth=this.lineWight;
        ctx.strokeStyle=this.lineColer;
        this.drawLine(ctx,min*0.5,min*0.2,min*0.5,0);
        this.drawLine(ctx,min*0.3,min*0.2,min*0.7,min*0.2);
        this.drawLine(ctx,min*0.5,min*0.8,min*0.5,min);
        ctx.stroke();
        if(this.value){
            ctx.beginPath();
            ctx.strokeStyle=this.switchColor[0];
            this.drawLine(ctx,min*0.5,min*0.2,min*0.5,min*0.8);
            ctx.rect(min*0.4,min*0.3,min*0.2,min*0.4);
            ctx.stroke();
        }else{
            ctx.beginPath();
            ctx.strokeStyle=this.switchColor[1];
            this.drawLine(ctx,min*0.1,min*0.6,min*0.5,min*0.8);
            this.drawLine(ctx,min*0.2,min*0.55,min*0.2,min*0.75);
            this.drawLine(ctx,min*0.45,min*0.65,min*0.45,min*0.85);
            this.drawLine(ctx,min*0.2,min*0.55,min*0.45,min*0.65);
            this.drawLine(ctx,min*0.2,min*0.75,min*0.45,min*0.85);
            ctx.stroke();
        }
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    /**手车 */
    draw2000(canvas){
        canvas.save();
        canvas.translate(this.cx+this.width/2,this.cy+this.height/2);
        canvas.rotate((Math.PI/180)*this.rotate);
        canvas.translate(-(this.cx+this.width/2),-(this.cy+this.height/2));
      
        if(this.value > 0){
            canvas.beginPath();
            this.drawLine(canvas,this.cx+this.width/2,this.cy,this.cx+this.width/2,this.cy+this.height);
            canvas.strokeStyle=this.lineColer;
            canvas.lineWidth=this.lineWight;
            canvas.stroke();    
            canvas.beginPath();
            this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height*(3/5),this.cx,this.cy+this.height/2);
            this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height*(3/5),this.cx+this.width,this.cy+this.height/2);
    
            canvas.lineWidth=this.lineWight;
            canvas.strokeStyle=this.switchColor[0];
        }else{
            canvas.beginPath();
            this.drawLine(canvas,this.cx+this.width/2,this.cy,this.cx+this.width/2,this.cy+this.height*(2/5));
            this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height*(3/5),this.cx+this.width/2,this.cy+this.height);
            canvas.strokeStyle=this.lineColer;
            canvas.lineWidth=this.lineWight;
            canvas.stroke();
            canvas.beginPath();
           
            this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height*(2/5),this.cx+this.width,this.cy+this.height*(1/5));
            this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height*(2/5),this.cx,this.cy+this.height*(1/5));
            this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height*(3/5),this.cx,this.cy+this.height*(2/5));
            this.drawLine(canvas,this.cx+this.width/2,this.cy+this.height*(3/5),this.cx+this.width,this.cy+this.height*(2/5));
            canvas.lineWidth=this.lineWight;
            canvas.strokeStyle=this.switchColor[1];
           
        }
        canvas.stroke();
        canvas.restore();
    }
    draw2001(ctx){
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;
        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;

        ctx.beginPath();
        this.drawLine(ctx,0,min/2,min,min/2);
        ctx.stroke();
        ctx.beginPath();
        
        ctx.arc(min/2,min/2,min/4,0,2*Math.PI);
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
            ctx.fill()
        }else{
            ctx.fillStyle=this.switchColor[1];
            ctx.fill()
        }
        
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2002(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.drawLine(ctx,0,min/2,min/4,min/2);
        this.drawLine(ctx,(min/4)+(min/4*2/7),min/3,min/4, min/2);
        this.drawLine(ctx,min/4+(min/4*2/7),min/3,min/4+(min/4*2/7)*2,min/3*2);
        this.drawLine(ctx,min/4+(min/4*2/7)*3,min/3,min/4+(min/4*2/7)*2,min/3*2);
        this.drawLine(ctx,min/4+(min/4*2/7)*3,min/3,min/4+(min/4*2/7)*4,min/3*2);
        this.drawLine(ctx,min/4+(min/4*2/7)*5,min/3,min/4+(min/4*2/7)*4,min/3*2);
        this.drawLine(ctx,min/4+(min/4*2/7)*5,min/3,min/4+(min/4*2/7)*6,min/3*2);
        this.drawLine(ctx, min/4+(min/4*2/7)*7,min/2,min/4+(min/4*2/7)*6,min/3*2);
        this.drawLine(ctx,min/4*3,min/2,min,min/2);
        ctx.stroke();
        ctx.beginPath();
        if(this.value){
            ctx.strokeStyle=this.switchColor[0];
        }else{
            ctx.strokeStyle=this.switchColor[1];
        }
        this.drawArrow(ctx, min/4,min/5*4, min/4*3,min/5,30,min/10,1,'#f36',"fill");
    
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2003(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.drawLine(ctx,0,min/2,min/21*10,min/2);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx,min/21*10+(min/21),min/2,min,min/2);
        ctx.stroke();

        ctx.beginPath();
        if(this.value){
            ctx.strokeStyle=this.switchColor[0];
        }else{
            ctx.strokeStyle=this.switchColor[1];
        }
        ctx.arc(min/21*10-(min/3/2),min/2,min/3/2,-1,1);
        this.drawLine(ctx,min/21*10+(min/21),min*0.3,min/21*10+(min/21),min*0.7);
        ctx.stroke();
        ctx.beginPath();
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2004(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.drawLine(ctx,0,min/2,min/21*10,min/2);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx,min/21*10+(min/21),min/2,min,min/2);
        ctx.stroke();

        ctx.beginPath();
        ctx.arc(min/21*10-(min/3/2),min/2,min/3/2,-1,1);
        this.drawLine(ctx,min/21*10+(min/21),min*0.3,min/21*10+(min/21),min*0.7);
        ctx.stroke();

        ctx.beginPath();
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
            this.drawArrow(ctx, min/4,min/5*4, min/4*3,min/5,30,min/10,1,'#f36',"fill");
            ctx.strokeStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];
            this.drawArrow(ctx, min/4,min/5*4, min/4*3,min/5,30,min/10,1,'#f36',"fill");
            ctx.strokeStyle=this.switchColor[1];
        }
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2005(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.drawLine(ctx,0,min*0.5,min*0.3,min*0.5);
        ctx.stroke();
        ctx.beginPath();

        ctx.arc(min*0.5,min*0.5,min*0.2,-1,2*Math.PI);
        ctx.stroke();

        this.drawLine(ctx,min*0.7,min*0.5,min,min*0.5);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx,min*0.4,min*0.65,min*0.4,min*0.35);
        this.drawLine(ctx,min*0.4,min*0.35,min*0.47,min*0.35);

        this.drawLine(ctx,min*0.47,min*0.65,min*0.47,min*0.35);
        this.drawLine(ctx,min*0.47,min*0.65,min*0.53,min*0.65);

        this.drawLine(ctx,min*0.53,min*0.65,min*0.53,min*0.35);
        this.drawLine(ctx,min*0.53,min*0.35,min*0.6,min*0.35);

        this.drawLine(ctx,min*0.6,min*0.65,min*0.6,min*0.35);
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
            ctx.strokeStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];
            ctx.strokeStyle=this.switchColor[1];
        }
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2006(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.drawLine(ctx,0,min*0.5,min*0.3,min*0.5);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min*0.4,min*0.5,min*0.1,0,Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min*0.6,min*0.5,min*0.1,Math.PI,2*Math.PI);
        ctx.stroke();
        this.drawLine(ctx,min*0.7,min*0.5,min,min*0.5);
        ctx.stroke();
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
            ctx.beginPath();
            ctx.arc(min*0.3,min*0.5,min*0.03,0,2*Math.PI);
            ctx.fill();
            ctx.beginPath();
            ctx.arc(min*0.7,min*0.5,min*0.03,0,2*Math.PI);
            ctx.fill();
            ctx.strokeStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];
            ctx.beginPath();
            ctx.arc(min*0.3,min*0.5,min*0.03,0,2*Math.PI);
            ctx.fill();
            ctx.beginPath();
            ctx.arc(min*0.7,min*0.5,min*0.03,0,2*Math.PI);
            ctx.fill();
            ctx.strokeStyle=this.switchColor[1];
        }
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2007(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.ellipse(min*0.5,min*0.5,min*0.3,min*0.15,0,0,Math.PI*2);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx,min*0.05,min*0.4,min*0.28,min*0.4);
        this.drawLine(ctx,min*0.05,min*0.6,min*0.28,min*0.6);
        this.drawLine(ctx,min*0.05,min*0.4,min*0.05,min*0.6);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx,min*0.95,min*0.4,min*0.72,min*0.4);
        this.drawLine(ctx,min*0.95,min*0.6,min*0.72,min*0.6);
        this.drawLine(ctx,min*0.95,min*0.4,min*0.95,min*0.6);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2008(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.drawLine(ctx,min*0.05,min*0.4,min*0.28,min*0.4);
        this.drawLine(ctx,min*0.05,min*0.6,min*0.28,min*0.6);
        ctx.stroke();
        ctx.beginPath();
        ctx.rect(min*0.28,min*0.3,min*0.7,min*0.4);
        ctx.fillRect(min*0.28,min*0.3,min*0.7,min*0.4);
        ctx.stroke();
        
        ctx.beginPath();
        this.drawLine(ctx,min*0.28,min*0.5,min*0.98,min*0.5);
        this.drawLine(ctx,min*0.62,min*0.3,min*0.62,min*0.7);
        ctx.stroke();

        ctx.beginPath();
        this.drawLine(ctx,min*0.62,min*0.3,min*0.98,min*0.2);
        this.drawLine(ctx,min*0.98,min*0.2,min*0.98,min*0.3);
        ctx.stroke();

        ctx.beginPath();
        ctx.moveTo(min*0.62,min*0.3);
        ctx.lineTo(min*0.98,min*0.2);
        ctx.lineTo(min*0.98,min*0.3);
        ctx.lineTo(min*0.62,min*0.3);
        ctx.fill();

        ctx.beginPath();
        ctx.moveTo(min*0.62,min*0.7);
        ctx.lineTo(min*0.98,min*0.8);
        ctx.lineTo(min*0.98,min*0.7);
        ctx.lineTo(min*0.62,min*0.7);
        ctx.fill();
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2009(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[1];
        }else{
            ctx.fillStyle=this.switchColor[1];

        }
        ctx.beginPath();
        ctx.ellipse(min*0.5,min*0.5,min*0.35,min*0.2,0,0,Math.PI*2); 
        ctx.fill();

        ctx.strokeStyle=this.switchColor[0];
        ctx.beginPath();
        this.drawLine(ctx,0,min*0.5,min*0.2,min*0.5);
        this.drawLine(ctx,min*0.8,min*0.5,min,min*0.5);
        ctx.stroke();

        ctx.beginPath();
        ctx.ellipse(min*0.5,min*0.5,min*0.03,min*0.05,0,0,Math.PI*2);
        ctx.moveTo(min*0.2,min*0.5);
        ctx.bezierCurveTo(min*0.2,min*0.35,min*0.5,min*0.35,min*0.5,min*0.45);
        ctx.moveTo(min*0.5,min*0.45);
        ctx.bezierCurveTo(min*0.5,min*0.35,min*0.8,min*0.35,min*0.8,min*0.5);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    //目前有问题， 无法填充
    draw2010(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.moveTo(min*0.05,min*0.2);
        ctx.lineTo(min*0.7,min*0.2);

        ctx.moveTo(min*0.7,min*0.2);
        ctx.bezierCurveTo(min*0.8,min*0.2,min*0.95,min*0.5,min*0.95,min*0.5);

        ctx.moveTo(min*0.05,min*0.8);
        ctx.lineTo(min*0.7,min*0.8);
        
        ctx.moveTo(min*0.7,min*0.8);
        ctx.bezierCurveTo(min*0.8,min*0.8,min*0.95,min*0.5,min*0.95,min*0.5);

        ctx.moveTo(min*0.05,min*0.2);
        ctx.bezierCurveTo(min*0.1,min*0.25,min*0.15,min*0.15,min*0.25,min*0.5);

        ctx.moveTo(min*0.05,min*0.8);
        ctx.bezierCurveTo(min*0.1,min*0.75,min*0.15,min*0.85,min*0.25,min*0.5);
        
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2011(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }
        ctx.beginPath();
        ctx.moveTo(min*0.1,min*0.15);
        ctx.lineTo(min*0.1,min*0.85);
        ctx.lineTo(min*0.75,min*0.5);
        ctx.lineTo(min*0.1,min*0.15);
        ctx.fill();
        ctx.stroke();

        ctx.beginPath();
        ctx.arc(min*0.75,min*0.5,min*0.05,0,2*Math.PI);
        ctx.fill();
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2012(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }
        ctx.beginPath();
        this.drawLine(ctx,min*0.05,min*0.5,min*0.45,min*0.5);
        this.drawLine(ctx,min*0.45,min*0.4,min*0.45,min*0.6);

        this.drawLine(ctx,min*0.55,min*0.35,min*0.55,min*0.65);
        this.drawLine(ctx,min*0.55,min*0.5,min*0.95,min*0.5);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2013(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }
        ctx.beginPath();
        this.drawLine(ctx,min*0.05,min*0.5,min*0.45,min*0.5);
        this.drawLine(ctx,min*0.45,min*0.4,min*0.45,min*0.6);

        this.drawLine(ctx,min*0.55,min*0.35,min*0.55,min*0.65);
        this.drawLine(ctx,min*0.55,min*0.5,min*0.95,min*0.5);

        this.drawLine(ctx,min*0.3,min*0.8,min*0.8,min*0.2);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2014(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }
        ctx.beginPath();
        this.drawLine(ctx,min*0.05,min*0.5,min*0.3,min*0.5);
        
        this.drawLine(ctx,min*0.3,min*0.5,min*0.6,min*0.5);

        ctx.fillStyle=this.switchColor[1]; 
        ctx.arc(min*0.3,min*0.5,min*0.02,0,2*Math.PI);
        ctx.fill();

        this.drawLine(ctx,min*0.6,min*0.4,min*0.95,min*0.4);
        ctx.fillStyle=this.switchColor[1]; 
        ctx.arc(min*0.6,min*0.4,min*0.02,0,2*Math.PI);
        ctx.fill();

        this.drawLine(ctx,min*0.6,min*0.6,min*0.95,min*0.6);
        ctx.fillStyle=this.switchColor[1]; 
        ctx.arc(min*0.6,min*0.6,min*0.02,0,2*Math.PI);
        ctx.fill();
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2015(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }

        ctx.beginPath();
        this.drawLine(ctx,min*0.05,min*0.4,min*0.3,min*0.4);
        ctx.stroke();
        ctx.beginPath();
        ctx.fillStyle=this.switchColor[1]; 
        ctx.arc(min*0.3,min*0.4,min*0.02,0,2*Math.PI);
        ctx.fill();
        ctx.stroke();

        ctx.beginPath();
        this.drawLine(ctx,min*0.05,min*0.6,min*0.3,min*0.6);
        ctx.stroke();
        ctx.beginPath();
        ctx.fillStyle=this.switchColor[1]; 
        ctx.arc(min*0.3,min*0.6,min*0.02,0,2*Math.PI);
        ctx.fill();
        ctx.stroke();

        ctx.beginPath();
        this.drawLine(ctx,min*0.7,min*0.4,min*0.95,min*0.4);
        ctx.stroke();
        ctx.beginPath();
        ctx.fillStyle=this.switchColor[1]; 
        ctx.arc(min*0.7,min*0.4,min*0.02,0,2*Math.PI);
        ctx.fill();
        ctx.stroke();

        ctx.beginPath();
        this.drawLine(ctx,min*0.7,min*0.6,min*0.95,min*0.6);
        ctx.stroke();
        ctx.beginPath();
        ctx.fillStyle=this.switchColor[1]; 
        ctx.arc(min*0.7,min*0.6,min*0.02,0,2*Math.PI);
        ctx.fill();
        ctx.stroke();

        ctx.beginPath();
        this.drawLine(ctx,min*0.4,min*0.6,min*0.65,min*0.55);
        ctx.stroke();
        ctx.beginPath();
        ctx.fillStyle=this.switchColor[1]; 
        ctx.arc(min*0.4,min*0.6,min*0.02,0,2*Math.PI);
        ctx.fill();
        ctx.stroke();

        ctx.beginPath();
        this.drawLine(ctx,min*0.4,min*0.4,min*0.65,min*0.35);
        ctx.stroke();
        ctx.beginPath();
        ctx.fillStyle=this.switchColor[1]; 
        ctx.arc(min*0.4,min*0.4,min*0.02,0,2*Math.PI);
        ctx.fill();
        ctx.stroke();

        ctx.beginPath();
        this.drawLine(ctx,min*0.53,min*0.38,min*0.53,min*0.58);

        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2016(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }
        ctx.beginPath();
        this.drawLine(ctx,min*0.5,min*0.05,min*0.5,min*0.7);
        this.drawLine(ctx,min*0.3,min*0.7,min*0.7,min*0.7);
        this.drawLine(ctx,min*0.35,min*0.8,min*0.65,min*0.8);
        this.drawLine(ctx,min*0.4,min*0.9,min*0.6,min*0.9);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2017(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }
        ctx.beginPath();
        this.drawLine(ctx,min*0.05,min*0.5,min*0.45,min*0.5);

        this.drawLine(ctx,min*0.55,min*0.5,min*0.95,min*0.5);

        this.drawLine(ctx,min*0.45,min*0.35,min*0.45,min*0.65);

        this.drawLine(ctx,min*0.55,min*0.4,min*0.55,min*0.6);

        ctx.font="20px Georgia";
        ctx.fillText("+",min*0.35,min*0.45)
        ctx.stroke();
        ctx.font="20px Georgia";
        ctx.fillText("-",min*0.6,min*0.45)
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2018(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }
        ctx.beginPath();
        this.drawLine(ctx,min*0.05,min*0.5,min*0.45,min*0.5);

        this.drawLine(ctx,min*0.55,min*0.5,min*0.95,min*0.5);

        this.drawLine(ctx,min*0.55,min*0.4,min*0.55,min*0.6);

        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(min*0.55,min*0.5);
        ctx.lineTo(min*0.4,min*0.4);
        ctx.lineTo(min*0.4,min*0.6);
        ctx.fill();
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2019(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }
        ctx.beginPath();
        this.drawLine(ctx,min*0.05,min*0.5,min*0.45,min*0.5);

        this.drawLine(ctx,min*0.55,min*0.5,min*0.95,min*0.5);

        this.drawLine(ctx,min*0.55,min*0.4,min*0.55,min*0.6);
        this.drawLine(ctx,min*0.55,min*0.4,min*0.6,min*0.35);
        this.drawLine(ctx,min*0.55,min*0.6,min*0.5,min*0.65);

        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(min*0.55,min*0.5);
        ctx.lineTo(min*0.4,min*0.4);
        ctx.lineTo(min*0.4,min*0.6);
        ctx.fill();
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2020(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }
        ctx.beginPath();
        ctx.arc(min*0.5,min*0.25,min*0.23,0,2*Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min*0.5,min*0.25,min*0.15,0,2*Math.PI);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx,min*0.5,min*0.5,min*0.5,min*0.8);
        this.drawLine(ctx,min*0.3,min*0.8,min*0.7,min*0.8);
        this.drawLine(ctx,min*0.35,min*0.9,min*0.65,min*0.9);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2021(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }
        ctx.beginPath();
        this.drawLine(ctx,min*0.05,min*0.5,min*0.4,min*0.5);

        this.drawLine(ctx,min*0.6,min*0.5,min*0.95,min*0.5);

        this.drawLine(ctx,min*0.4,min*0.35,min*0.4,min*0.65);

        this.drawLine(ctx,min*0.6,min*0.35,min*0.6,min*0.65);
        ctx.stroke();

        ctx.beginPath();
        ctx.rect(min*0.45,min*0.35,min*0.1,min*0.3);
        ctx.fill();
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2022(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.drawLine(ctx,0,min/2,min/4,min/2);
        this.drawLine(ctx,(min/4)+(min/4*2/7),min/3,min/4,min/2);
        this.drawLine(ctx,min/4+(min/4*2/7),min/3,min/4+(min/4*2/7)*2,min/3*2);
        this.drawLine(ctx,min/4+(min/4*2/7)*3,min/3,min/4+(min/4*2/7)*2,min/3*2);
        this.drawLine(ctx,min/4+(min/4*2/7)*3,min/3,min/4+(min/4*2/7)*4,min/3*2);
        this.drawLine(ctx,min/4+(min/4*2/7)*5,min/3,min/4+(min/4*2/7)*4,min/3*2);
        this.drawLine(ctx,min/4+(min/4*2/7)*5,min/3,min/4+(min/4*2/7)*6,min/3*2);
        this.drawLine(ctx,min/4+(min/4*2/7)*7,min/2,min/4+(min/4*2/7)*6,min/3*2);
        this.drawLine(ctx,min/4*3,min/2,min,min/2);
        ctx.stroke();
        ctx.beginPath();
        if(this.value){
            ctx.strokeStyle=this.switchColor[0];
        }else{
            ctx.strokeStyle=this.switchColor[1];
        }
        this.drawArrow(ctx, min*0.55,min*0.9, min*0.55,min*0.65,30,min*0.1,1,'#f36',"fill");
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2023(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.drawLine(ctx,0,min/2,min/4,min/2);
        this.drawLine(ctx,(min/4)+(min/4*2/7),min/3,min/4,min/2);
        this.drawLine(ctx,min/4+(min/4*2/7),min/3,min/4+(min/4*2/7)*2,min/3*2);
        this.drawLine(ctx,min/4+(min/4*2/7)*3,min/3,min/4+(min/4*2/7)*2,min/3*2);
        this.drawLine(ctx,min/4+(min/4*2/7)*3,min/3,min/4+(min/4*2/7)*4,min/3*2);
        this.drawLine(ctx,min/4+(min/4*2/7)*5,min/3,min/4+(min/4*2/7)*4,min/3*2);
        this.drawLine(ctx,min/4+(min/4*2/7)*5,min/3,min/4+(min/4*2/7)*6,min/3*2);
        this.drawLine(ctx,min/4+(min/4*2/7)*7,min/2,min/4+(min/4*2/7)*6,min/3*2);
        this.drawLine(ctx,min/4*3,min/2,min,min/2);
        ctx.stroke();
        ctx.beginPath();
        if(this.value){
            ctx.strokeStyle=this.switchColor[0];
        }else{
            ctx.strokeStyle=this.switchColor[1];
        }
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2024(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }
        ctx.beginPath();
        this.drawLine(ctx,min*0.05,min*0.6,min*0.45,min*0.6);

        this.drawLine(ctx,min*0.55,min*0.6,min*0.95,min*0.6);

        this.drawLine(ctx,min*0.55,min*0.5,min*0.55,min*0.7);

        ctx.stroke();

        ctx.beginPath();
        ctx.moveTo(min*0.55,min*0.6);
        ctx.lineTo(min*0.4,min*0.5);
        ctx.lineTo(min*0.4,min*0.7);
        ctx.fill();
        ctx.stroke();

        ctx.beginPath();
        ctx.arc(min*0.5,min*0.6,min*0.25,0,2*Math.PI);
        ctx.stroke();
        
        ctx.beginPath();
        this.drawArrow(ctx, min*0.6,min*0.35,min*0.9,min*0.1,30,min*0.1,1,'#f36',"fill");
        ctx.stroke();
        ctx.beginPath();
        this.drawArrow(ctx, min*0.7,min*0.45,min*0.95,min*0.3,30,min*0.1,1,'#f36',"fill");
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2025(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }
        ctx.beginPath();
        this.drawLine(ctx,min*0.4,min*0.2,min*0.4,min*0.9);

        this.drawLine(ctx,min*0.6,min*0.2,min*0.6,min*0.9);
        ctx.stroke();

        ctx.beginPath();
        ctx.ellipse(min*0.28,min*0.3,min*0.175/2,min*0.1,-Math.PI/2,0,Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.ellipse(min*0.28,min*0.475,min*0.175/2,min*0.1,-Math.PI/2,0,Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.ellipse(min*0.28,min*0.65,min*0.175/2,min*0.1,-Math.PI/2,0,Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.ellipse(min*0.28,min*0.83,min*0.175/2,min*0.1,-Math.PI/2,0,Math.PI);
        ctx.stroke();

        ctx.beginPath();
        ctx.ellipse(min*0.72,min*0.3,min*0.175/2,min*0.1,Math.PI/2,0,Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.ellipse(min*0.72,min*0.475,min*0.175/2,min*0.1,Math.PI/2,0,Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.ellipse(min*0.72,min*0.65,min*0.175/2,min*0.1,Math.PI/2,0,Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.ellipse(min*0.72,min*0.83,min*0.175/2,min*0.1,Math.PI/2,0,Math.PI);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2026(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }
        ctx.beginPath();
        this.drawLine(ctx,min*0.05,min*0.5,min*0.17,min*0.5);

        this.drawLine(ctx,min*0.87,min*0.5,min*0.95,min*0.5);
        ctx.stroke();

        ctx.beginPath();
        ctx.ellipse(min*0.25,min*0.5,min*0.175/2,min*0.15,Math.PI,0,Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.ellipse(min*0.425,min*0.5,min*0.175/2,min*0.15,Math.PI,0,Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.ellipse(min*0.6,min*0.5,min*0.175/2,min*0.15,Math.PI,0,Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.ellipse(min*0.78,min*0.5,min*0.175/2,min*0.15,Math.PI,0,Math.PI);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2027(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }
        ctx.beginPath();
        this.drawLine(ctx,min*0.05,min*0.65,min*0.3,min*0.65);

        this.drawLine(ctx,min*0.55,min*0.65,min*0.95,min*0.65);
        ctx.stroke();

        ctx.beginPath();
        ctx.moveTo(min*0.55,min*0.65);
        ctx.lineTo(min*0.4,min*0.55);
        ctx.lineTo(min*0.4,min*0.75);
        ctx.fill();
        ctx.stroke();

        ctx.beginPath();
        ctx.arc(min*0.42,min*0.65,min*0.12,0,2*Math.PI);
        ctx.stroke();

        ctx.beginPath();
        this.drawLine(ctx,min*0.65,min*0.4,min*0.5,min*0.55);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx,min*0.65,min*0.4,min*0.65,min*0.5);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx,min*0.65,min*0.4,min*0.55,min*0.4);
        ctx.stroke();

        ctx.beginPath();
        this.drawLine(ctx,min*0.75,min*0.5,min*0.55,min*0.6);
        ctx.stroke();

        ctx.beginPath();
        this.drawLine(ctx,min*0.75,min*0.5,min*0.75,min*0.55);
        ctx.stroke();

        ctx.beginPath();
        this.drawLine(ctx,min*0.75,min*0.5,min*0.65,min*0.5);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2028(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }

        ctx.beginPath();
        this.drawLine(ctx,min*0.5,min*0.05,min*0.5,min*0.45);
        this.drawLine(ctx,min*0.5,min*0.45,min*0.45,min*0.35);
        this.drawLine(ctx,min*0.5,min*0.45,min*0.55,min*0.35);

        this.drawLine(ctx,min*0.5,min*0.55,min*0.45,min*0.45);
        this.drawLine(ctx,min*0.5,min*0.55,min*0.55,min*0.45);
        this.drawLine(ctx,min*0.5,min*0.55,min*0.5,min*0.95);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2029(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }

        ctx.beginPath();
        ctx.rect(min*0.05,min*0.4,min*0.9,min*0.2);
        ctx.stroke();

        ctx.beginPath();
        ctx.arc(min*0.5,min*0.5,min*0.25,0,2*Math.PI);
        ctx.fill();
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2030(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.drawLine(ctx,min*0.05,min*0.6,min*0.95,min*0.6);
        ctx.stroke();

        ctx.beginPath();
        ctx.rect(min*0.25,min*0.5,min*0.55,min*0.2);
        ctx.fill();
        ctx.stroke();

        ctx.beginPath();
        ctx.moveTo(min*0.5,min*0.65);
        ctx.lineTo(min*0.3,min*0.4);
        ctx.lineTo(min*0.75,min*0.4);
        ctx.fill();
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2031(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }

        ctx.beginPath();
        this.drawLine(ctx,min*0.05,min*0.3,min*0.5,min*0.3);
        this.drawLine(ctx,min*0.5,min*0.3,min*0.6,min*0.5);
        this.drawLine(ctx,min*0.05,min*0.5,min*0.5,min*0.5);
        this.drawLine(ctx,min*0.05,min*0.7,min*0.5,min*0.7);
        this.drawLine(ctx,min*0.5,min*0.7,min*0.6,min*0.5);
        ctx.stroke();

        ctx.beginPath();
        ctx.arc(min*0.7,min*0.5,min*0.2,0,2*Math.PI);
        ctx.fill();
        ctx.stroke();

        ctx.beginPath();
        ctx.fillStyle="#000";
        ctx.font="30px Georgia";
        ctx.fillText("M",min*0.6,min*0.55);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2032(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }

        ctx.beginPath();
        this.drawLine(ctx,min*0.05,min*0.5,min*0.45,min*0.5);
        this.drawLine(ctx,min*0.45,min*0.35,min*0.45,min*0.65);
        this.drawLine(ctx,min*0.55,min*0.5,min*0.95,min*0.5);
        ctx.stroke();

        ctx.beginPath();
        ctx.ellipse(min*0.7,min*0.5,min*0.15,min*0.15,Math.PI/2,0,Math.PI);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2033(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }
        ctx.beginPath();
        this.drawLine(ctx,min*0.05,min*0.51,min*0.17,min*0.51);

        this.drawLine(ctx,min*0.85,min*0.51,min*0.95,min*0.51);
        ctx.stroke();

        ctx.beginPath();
        ctx.ellipse(min*0.25,min*0.5,min*0.1/2,min*0.1,Math.PI,0,Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.ellipse(min*0.35,min*0.5,min*0.1/2,min*0.1,Math.PI,0,Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.ellipse(min*0.45,min*0.5,min*0.1/2,min*0.1,Math.PI,0,Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.ellipse(min*0.55,min*0.5,min*0.1/2,min*0.1,Math.PI,0,Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.ellipse(min*0.65,min*0.5,min*0.1/2,min*0.1,Math.PI,0,Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.ellipse(min*0.75,min*0.5,min*0.1/2,min*0.1,Math.PI,0,Math.PI);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2034(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }
        ctx.beginPath();
        this.drawLine(ctx,min*0.05,min*0.51,min*0.17,min*0.51);

        this.drawLine(ctx,min*0.85,min*0.51,min*0.95,min*0.51);

        this.drawLine(ctx,min*0.3,min*0.7,min*0.7,min*0.25);
        this.drawLine(ctx,min*0.7,min*0.25,min*0.65,min*0.25);
        this.drawLine(ctx,min*0.7,min*0.25,min*0.7,min*0.3);
        ctx.stroke();

        ctx.beginPath();
        ctx.ellipse(min*0.25,min*0.5,min*0.1/2,min*0.1,Math.PI,0,Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.ellipse(min*0.35,min*0.5,min*0.1/2,min*0.1,Math.PI,0,Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.ellipse(min*0.45,min*0.5,min*0.1/2,min*0.1,Math.PI,0,Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.ellipse(min*0.55,min*0.5,min*0.1/2,min*0.1,Math.PI,0,Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.ellipse(min*0.65,min*0.5,min*0.1/2,min*0.1,Math.PI,0,Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.ellipse(min*0.75,min*0.5,min*0.1/2,min*0.1,Math.PI,0,Math.PI);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2035(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.moveTo(0,min*0.5);
        ctx.lineTo(min*0.15,min*0.5);
        ctx.lineTo(min*0.2,min*0.4);
        ctx.lineTo(min*0.25,min*0.6);
        ctx.lineTo(min*0.3,min*0.4);
        ctx.lineTo(min*0.35,min*0.6);
        ctx.lineTo(min*0.4,min*0.4);
        ctx.lineTo(min*0.45,min*0.6);
        ctx.lineTo(min*0.5,min*0.4);
        ctx.lineTo(min*0.55,min*0.6);
        ctx.lineTo(min*0.6,min*0.4);
        ctx.lineTo(min*0.65,min*0.6);
        ctx.lineTo(min*0.7,min*0.4);
        ctx.lineTo(min*0.75,min*0.6);
        ctx.lineTo(min*0.8,min*0.4);
        ctx.lineTo(min*0.85,min*0.5);
        ctx.lineTo(min*1,min*0.5);
        ctx.stroke();
        ctx.beginPath();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2036(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.moveTo(0,min*0.5);
        ctx.lineTo(min*0.15,min*0.5);
        ctx.lineTo(min*0.2,min*0.4);
        ctx.lineTo(min*0.25,min*0.6);
        ctx.lineTo(min*0.3,min*0.4);
        ctx.lineTo(min*0.35,min*0.6);
        ctx.lineTo(min*0.4,min*0.4);
        ctx.lineTo(min*0.45,min*0.6);
        ctx.lineTo(min*0.5,min*0.4);
        ctx.lineTo(min*0.55,min*0.6);
        ctx.lineTo(min*0.6,min*0.4);
        ctx.lineTo(min*0.65,min*0.6);
        ctx.lineTo(min*0.7,min*0.4);
        ctx.lineTo(min*0.75,min*0.6);
        ctx.lineTo(min*0.8,min*0.4);
        ctx.lineTo(min*0.85,min*0.5);
        ctx.lineTo(min*1,min*0.5);
        ctx.stroke();
        ctx.beginPath();
        ctx.rect(min*0.15,min*0.4,min*0.7,min*0.2);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2037(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.drawLine(ctx,min*0.05,min*0.5,min*0.35,min*0.5);
        this.drawLine(ctx,min*0.65,min*0.5,min*0.95,min*0.5);

        this.drawLine(ctx,min*0.4,min*0.425,min*0.4,min*0.55);
        this.drawLine(ctx,min*0.6,min*0.425,min*0.6,min*0.55);

        this.drawLine(ctx,min*0.4,min*0.5,min*0.6,min*0.5);
        ctx.stroke();
        ctx.beginPath();
        ctx.rect(min*0.35,min*0.425,min*0.3,min*0.15);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2038(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }
        ctx.beginPath();
        ctx.rect(min*0.35,min*0.3,min*0.35,min*0.2);
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(min*0.35,min*0.3);
        ctx.lineTo(min*0.35,min*0.1);
        ctx.lineTo(min*0.95,min*0.1);
        ctx.lineTo(min*0.95,min*0.7);
        ctx.lineTo(min*0.15,min*0.7);
        ctx.lineTo(min*0.15,min*0.3);
        ctx.lineTo(min*0.35,min*0.3);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx,min*0.5,min*0.7,min*0.5,min*0.95);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2039(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }
        ctx.beginPath();
        ctx.rect(min*0.4,min*0.45,min*0.2,min*0.1);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx,min*0.05,min*0.5,min*0.95,min*0.5);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2040(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }
        ctx.beginPath();
        ctx.rect(min*0.4,min*0.45,min*0.2,min*0.1);
        ctx.stroke();
        
        ctx.beginPath();
        this.drawLine(ctx,min*0.05,min*0.5,min*0.4,min*0.5);
        this.drawLine(ctx,min*0.6,min*0.5,min*0.95,min*0.5);
        ctx.stroke();

        ctx.beginPath();
        this.drawLine(ctx,min*0.3,min*0.7,min*0.7,min*0.25);
        this.drawLine(ctx,min*0.7,min*0.25,min*0.65,min*0.25);
        this.drawLine(ctx,min*0.7,min*0.25,min*0.7,min*0.3);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }

    /** */
    draw2101 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        ctx.arc(min * 0.5, min * 0.5, min * 0.5, 0, 2 * Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx, min * 0.2, min * 0.4, min * 0.8, min * 0.4);
        this.drawLine(ctx, min * 0.2, min * 0.6, min * 0.8, min * 0.6);
        this.drawLine(ctx, min * 0.5, min * 0.2, min * 0.5, min * 0.4);
        this.drawLine(ctx, min * 0.5, min * 0.6, min * 0.5, min * 0.8);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2102 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.fillStyle = this.switchColor[0];
        ctx.beginPath();
        ctx.rect(min * 0.03, min * 0.49, min * 0.2, min * 0.04);
        ctx.rect(min * 0.23, min * 0.48, min * 0.06, min * 0.06);
        ctx.rect(min * 0.3, min * 0.4, min * 0.3, min * 0.2);
        ctx.rect(min * 0.3, min * 0.4, min * 0.3, min * 0.2);
        ctx.rect(min * 0.6, min * 0.44, min * 0.06, min * 0.05);
        ctx.rect(min * 0.6, min * 0.52, min * 0.06, min * 0.05);
        ctx.rect(min * 0.66, min * 0.45, min * 0.2, min * 0.03);
        ctx.rect(min * 0.66, min * 0.53, min * 0.2, min * 0.03);
        ctx.fill();
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        ctx.rect(min * 0.32, min * 0.42, min * 0.26, min * 0.16);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2103 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.fillStyle = this.switchColor[0];
        ctx.beginPath();
        ctx.rect(min * 0.6, min * 0.49, min * 0.3, min * 0.04);
        ctx.rect(min * 0.1, min * 0.45, min * 0.3, min * 0.03);
        ctx.rect(min * 0.1, min * 0.53, min * 0.3, min * 0.03);
        ctx.arc(min * 0.5, min * 0.5, min * 0.15, 0, 2 * Math.PI);
        ctx.fill();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2104 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx, min * 0.3, min * 0.4, min * 0.7, min * 0.4);
        this.drawLine(ctx, min * 0.4, min * 0.5, min * 0.6, min * 0.5);
        this.drawLine(ctx, min * 0.3, min * 0.6, min * 0.7, min * 0.6);
        this.drawLine(ctx, min * 0.4, min * 0.7, min * 0.6, min * 0.7);
        this.drawLine(ctx, min * 0.5, min * 0.2, min * 0.5, min * 0.4);
        this.drawLine(ctx, min * 0.5, min * 0.7, min * 0.5, min * 0.9);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2105 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];
        console.log(this)
        if (this.value == 1) {
            ctx.beginPath();
            this.drawLine(ctx, min * 0.5, min * 0.35, min * 0.5, min * 0.2);
            ctx.stroke();

        } else {
            ctx.beginPath();
            this.drawLine(ctx, min * 0.5, min * 0.35, min * 0.55, min * 0.2);
            ctx.stroke();
        }
        ctx.beginPath();
        ctx.strokeText("H", min * 0.33, min * 0.35);
        ctx.strokeText("A", min * 0.60, min * 0.35);
        ctx.strokeText(this.value, min * 0.45, min * 0.25);
        this.drawLine(ctx, min * 0.33, min * 0.55, min * 0.67, min * 0.55);
        this.drawLine(ctx, min * 0.25, min * 0.6, min * 0.1, min * 0.6);
        this.drawLine(ctx, min * 0.75, min * 0.6, min * 0.9, min * 0.6);
        this.drawLine(ctx, min * 0.33, min * 0.85, min * 0.67, min * 0.85);
        this.drawLine(ctx, min * 0.25, min * 0.9, min * 0.1, min * 0.9);
        this.drawLine(ctx, min * 0.75, min * 0.9, min * 0.9, min * 0.9);
        this.drawLine(ctx, min * 0.5, min * 0.35, min * 0.5, min * 0.85);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.3, min * 0.6, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.7, min * 0.6, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.3, min * 0.9, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.7, min * 0.9, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2106 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        //min为绘制canvas的宽度(高度)
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx, min * 0.2, min * 0.3, min * 0.8, min * 0.2);
        this.drawLine(ctx, min * 0.5, min * 0.25, min * 0.5, min * 0.7);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.2, min * 0.35, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.8, min * 0.25, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        //填充三角形（等边）
        ctx.beginPath();
        ctx.moveTo(min * 0.2, min * 0.9); //从A（100,0）开始
        ctx.lineTo(min * 0.5, min * 0.7); //从A(100,0)开始，画到B (0,173)结束
        ctx.lineTo(min * 0.8, min * 0.9); //B(0,173)-C(200,173)
        ctx.fillStyle = this.switchColor[0];
        ctx.fill(); //闭合形状并且以填充方式绘制出来
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2107 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx, min * 0.2, min * 0.8, min * 0.9, min * 0.1);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.2, min * 0.85, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.7, min * 0.85, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        //填充三角形（等边）
        ctx.beginPath();
        ctx.moveTo(min * 0.2, min * 0.8); //从A（100,0）开始
        ctx.lineTo(min * 0.7, min * 0.3); //从A(100,0)开始，画到B (0,173)结束
        ctx.lineTo(min * 0.7, min * 0.65); //B(0,173)-C(200,173)
        ctx.fillStyle = this.switchColor[0];
        ctx.fill(); //闭合形状并且以填充方式绘制出来ctx.fill(); //闭合形状并且以填充方式绘制出来
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2108 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx, min * 0.2, min * 0.5, min * 0.8, min * 0.5);
        this.drawLine(ctx, min * 0.5, min * 0.2, min * 0.5, min * 0.5);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.2, min * 0.45, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.8, min * 0.45, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2109 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx, min * 0.1, min * 0.3, min * 0.9, min * 0.3);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.1, min * 0.35, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.9, min * 0.35, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        //填充三角形（等边）
        ctx.beginPath();
        ctx.moveTo(min * 0.2, min * 0.3); //从A（100,0）开始
        ctx.lineTo(min * 0.8, min * 0.3); //从A(100,0)开始，画到B (0,173)结束
        ctx.lineTo(min * 0.8, min * 0.55); //B(0,173)-C(200,173)
        ctx.fillStyle = this.switchColor[0];
        ctx.fill(); //闭合形状并且以填充方式绘制出来
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2110 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx, min * 0.2, min * 0.8, min * 0.45, min * 0.8);
        this.drawLine(ctx, min * 0.2, min * 0.8, min * 0.3, min * 0.7);
        this.drawLine(ctx, min * 0.2, min * 0.8, min * 0.3, min * 0.9);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.5, min * 0.2, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.3, min * 0.5, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.7, min * 0.5, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.15, min * 0.8, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.5, min * 0.8, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.85, min * 0.8, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2112 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx, min * 0.2, min * 0.5, min * 0.8, min * 0.5);
        this.drawLine(ctx, min * 0.3, min * 0.35, min * 0.1, min * 0.65);
        this.drawLine(ctx, min * 0.5, min * 0.35, min * 0.3, min * 0.65);
        this.drawLine(ctx, min * 0.7, min * 0.35, min * 0.5, min * 0.65);
        this.drawLine(ctx, min * 0.9, min * 0.35, min * 0.8, min * 0.5);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.23, min * 0.35, min * 0.03, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.05, min * 0.62, min * 0.03, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.43, min * 0.35, min * 0.03, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.25, min * 0.62, min * 0.03, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.63, min * 0.35, min * 0.03, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.45, min * 0.62, min * 0.03, 0, Math.PI * 2, false);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2113 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx, min * 0.2, min * 0.3, min * 0.8, min * 0.2);
        this.drawLine(ctx, min * 0.5, min * 0.25, min * 0.5, min * 0.7);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.2, min * 0.35, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.8, min * 0.25, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.5, min * 0.8, min * 0.17, 0, Math.PI * 2, false);
        ctx.fillStyle = this.switchColor[0];
        ctx.fill();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2116 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        this.drawLine(ctx, 0, min / 2, min * 0.4, min / 2);
        this.drawLine(ctx, min * 0.6, min / 2, min, min / 2);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.5, min * 0.5, min * 0.1, Math.PI * 1.1, Math.PI * 1.9, false);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2117 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        let x = min * 0.5,
            y = min * 0.3,
            r = min * 0.2;
        ctx.beginPath();
        ctx.moveTo(x, y - r / 2); //从A（100,0）开始
        ctx.lineTo(x - Math.cos(Math.PI / 6) * r * 0.5, y + r / 4); //从A(100,0)开始，画到B (0,173)结束
        ctx.lineTo(x + Math.cos(Math.PI / 6) * r * 0.5, y + r / 4); //B(0,173)-C(200,173)
        ctx.closePath();
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(x, y, r, Math.PI * 2, 0, false);
        ctx.stroke();
        let x2 = min * 0.5,
            y2 = min * 0.65,
            r2 = min * 0.2;
        ctx.beginPath();
        this.drawLine(ctx, x2, y2, x2 - Math.cos(Math.PI / 6) * r2 * 0.5, y2 - r2 / 2);
        this.drawLine(ctx, x2, y2, x2 + Math.cos(Math.PI / 6) * r2 * 0.5, y2 - r2 / 2);
        this.drawLine(ctx, x2, y2, x2, y2 + r2 / 2);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(x2, y2, r2, Math.PI * 2, 0, false);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2118 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        let x = min * 0.5,
            y = min * 0.65,
            r = min * 0.2;
        ctx.beginPath();
        ctx.moveTo(x, y - r / 2); //从A（100,0）开始
        ctx.lineTo(x - Math.cos(Math.PI / 6) * r * 0.5, y + r / 4); //从A(100,0)开始，画到B (0,173)结束
        ctx.lineTo(x + Math.cos(Math.PI / 6) * r * 0.5, y + r / 4); //B(0,173)-C(200,173)
        ctx.closePath();
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(x, y, r, Math.PI * 2, 0, false);
        ctx.stroke();
        let x2 = min * 0.5,
            y2 = min * 0.3,
            r2 = min * 0.2;
        ctx.beginPath();
        this.drawLine(ctx, x2, y2, x2 - Math.cos(Math.PI / 6) * r2 * 0.5, y2 - r2 / 2);
        this.drawLine(ctx, x2, y2, x2 + Math.cos(Math.PI / 6) * r2 * 0.5, y2 - r2 / 2);
        this.drawLine(ctx, x2, y2, x2, y2 + r2 / 2);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(x2, y2, r2, Math.PI * 2, 0, false);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2119 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        ctx.beginPath();
        let x = min * 0.6,
            y = min * 0.35,
            r = min * 0.05;
        ctx.moveTo(x - r, y); //从A（100,0）开始
        ctx.lineTo(x, y); //从A(100,0)开始，画到B (0,173)结束
        ctx.lineTo(x, y + r); //B(0,173)-C(200,173)
        ctx.closePath();
        this.drawLine(ctx, 0, min / 2, min * 0.4, min / 2);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx, min * 0.57, min * 0.38, min * 0.35, min * 0.65);
        this.drawLine(ctx, min * 0.4, min * 0.35, min * 0.4, min * 0.65);
        this.drawLine(ctx, min * 0.5, min * 0.35, min * 0.5, min * 0.65);
        this.drawLine(ctx, min * 0.5, min / 2, min, min / 2);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2120 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        this.drawLine(ctx, min * 0.1, min * 0.46, min * 0.3, min * 0.46);
        this.drawLine(ctx, min * 0.1, min * 0.53, min * 0.3, min * 0.53);
        this.drawLine(ctx, min * 0.7, min * 0.4, min * 0.9, min * 0.25);
        this.drawLine(ctx, min * 0.7, min * 0.6, min * 0.9, min * 0.75);
        this.drawLine(ctx, min * 0.9, min * 0.25, min * 0.9, min * 0.75);
        ctx.stroke();
        ctx.beginPath();
        ctx.rect(min * 0.3, min * 0.4, min * 0.4, min * 0.2);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2121 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        let x = min * 0.5,
            y = min * 0.35,
            r = min * 0.2;
        ctx.beginPath();
        ctx.moveTo(x, y - r / 2); //从A（100,0）开始
        ctx.lineTo(x - Math.cos(Math.PI / 6) * r * 0.5, y + r / 4); //从A(100,0)开始，画到B (0,173)结束
        ctx.lineTo(x + Math.cos(Math.PI / 6) * r * 0.5, y + r / 4); //B(0,173)-C(200,173)
        ctx.closePath();
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(x, y, r, Math.PI * 2, 0, false);
        ctx.stroke();
        let x2 = min * 0.35,
            y2 = min * 0.65,
            r2 = min * 0.2;
        ctx.beginPath();
        ctx.moveTo(x2, y2 - r2 / 2); //从A（100,0）开始
        ctx.lineTo(x2 - Math.cos(Math.PI / 6) * r2 * 0.5, y2 + r2 / 4); //从A(100,0)开始，画到B (0,173)结束
        ctx.lineTo(x2 + Math.cos(Math.PI / 6) * r2 * 0.5, y2 + r2 / 4); //B(0,173)-C(200,173)
        ctx.closePath();
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(x2, y2, r2, Math.PI * 2, 0, false);
        ctx.stroke();
        let x3 = min * 0.65,
            y3 = min * 0.65,
            r3 = min * 0.2;
        ctx.beginPath();
        ctx.moveTo(x3, y3 - r3 / 2); //从A（100,0）开始
        ctx.lineTo(x3 - Math.cos(Math.PI / 6) * r3 * 0.5, y3 + r3 / 4); //从A(100,0)开始，画到B (0,173)结束
        ctx.lineTo(x3 + Math.cos(Math.PI / 6) * r3 * 0.5, y3 + r3 / 4); //B(0,173)-C(200,173)
        ctx.closePath();
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(x3, y3, r3, Math.PI * 2, 0, false);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2122 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        let x = min * 0.5,
            y = min * 0.35,
            r = min * 0.2;
        ctx.beginPath();
        ctx.moveTo(x, y - r / 2); //从A（100,0）开始
        ctx.lineTo(x - Math.cos(Math.PI / 6) * r * 0.5, y + r / 4); //从A(100,0)开始，画到B (0,173)结束
        ctx.lineTo(x + Math.cos(Math.PI / 6) * r * 0.5, y + r / 4); //B(0,173)-C(200,173)
        ctx.closePath();
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(x, y, r, Math.PI * 2, 0, false);
        ctx.stroke();
        let x2 = min * 0.35,
            y2 = min * 0.65,
            r2 = min * 0.2;
        ctx.beginPath();
        ctx.moveTo(x2, y2 - r2 / 2); //从A（100,0）开始
        ctx.lineTo(x2 - Math.cos(Math.PI / 6) * r2 * 0.5, y2 + r2 / 4); //从A(100,0)开始，画到B (0,173)结束
        ctx.lineTo(x2 + Math.cos(Math.PI / 6) * r2 * 0.5, y2 + r2 / 4); //B(0,173)-C(200,173)
        ctx.closePath();
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(x2, y2, r2, Math.PI * 2, 0, false);
        ctx.stroke();
        let x3 = min * 0.65,
            y3 = min * 0.65,
            r3 = min * 0.2;
        ctx.beginPath();
        this.drawLine(ctx, x3, y3, x3 - Math.cos(Math.PI / 6) * r3 * 0.5, y3 - r3 / 2);
        this.drawLine(ctx, x3, y3, x3 + Math.cos(Math.PI / 6) * r3 * 0.5, y3 - r3 / 2);
        this.drawLine(ctx, x3, y3, x3, y3 + r2 / 2);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(x3, y3, r3, Math.PI * 2, 0, false);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2123 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        let x = min * 0.5,
            y = min * 0.35,
            r = min * 0.2;
        ctx.beginPath();
        this.drawLine(ctx, x, y, x - Math.cos(Math.PI / 6) * r * 0.5, y - r / 2);
        this.drawLine(ctx, x, y, x + Math.cos(Math.PI / 6) * r * 0.5, y - r / 2);
        this.drawLine(ctx, x, y, x, y + r / 2);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(x, y, r, Math.PI * 2, 0, false);
        ctx.stroke();
        let x2 = min * 0.35,
            y2 = min * 0.65,
            r2 = min * 0.2;
        ctx.beginPath();
        this.drawLine(ctx, x2, y2, x2 - Math.cos(Math.PI / 6) * r2 * 0.5, y2 - r2 / 2);
        this.drawLine(ctx, x2, y2, x2 + Math.cos(Math.PI / 6) * r2 * 0.5, y2 - r2 / 2);
        this.drawLine(ctx, x2, y2, x2, y2 + r2 / 2);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(x2, y2, r2, Math.PI * 2, 0, false);
        ctx.stroke();
        let x3 = min * 0.65,
            y3 = min * 0.65,
            r3 = min * 0.2;
        ctx.beginPath();
        this.drawLine(ctx, x3, y3, x3 - Math.cos(Math.PI / 6) * r3 * 0.5, y3 - r3 / 2);
        this.drawLine(ctx, x3, y3, x3 + Math.cos(Math.PI / 6) * r3 * 0.5, y3 - r3 / 2);
        this.drawLine(ctx, x3, y3, x3, y3 + r3 / 2);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(x3, y3, r3, Math.PI * 2, 0, false);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2124 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx, min * 0.2, min * 0.3, min * 0.8, min * 0.2);
        this.drawLine(ctx, min * 0.5, min * 0.25, min * 0.5, min * 0.95);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.2, min * 0.35, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.8, min * 0.25, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        //填充三角形（等边）
        ctx.beginPath();
        ctx.moveTo(min * 0.3, min * 0.95); //从A（100,0）开始
        ctx.lineTo(min * 0.5, min * 0.6); //从A(100,0)开始，画到B (0,173)结束
        ctx.lineTo(min * 0.5, min * 0.95); //B(0,173)-C(200,173)
        ctx.fillStyle = this.switchColor[0];
        ctx.fill(); //闭合形状并且以填充方式绘制出来
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2125 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        this.drawLine(ctx, 0, min / 2, min * 0.4, min / 2);
        this.drawLine(ctx, min * 0.6, min / 2, min, min / 2);
        this.drawLine(ctx, min * 0.45, min * 0.45, min * 0.55, min * 0.55);
        this.drawLine(ctx, min * 0.45, min * 0.55, min * 0.55, min * 0.45);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.5, min * 0.5, min * 0.1, 0, Math.PI * 2, false);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2126 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        this.drawLine(ctx, 0, min / 2, min * 0.4, min / 2);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx, min * 0.35, min * 0.3, min * 0.4, min * 0.35);
        this.drawLine(ctx, min * 0.35, min * 0.7, min * 0.4, min * 0.65);
        this.drawLine(ctx, min * 0.4, min * 0.35, min * 0.4, min * 0.65);
        this.drawLine(ctx, min * 0.5, min * 0.3, min * 0.5, min * 0.7);
        this.drawLine(ctx, min * 0.5, min / 2, min, min / 2);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2127 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        this.drawLine(ctx, 0, min / 2, min * 0.3, min / 2);
        this.drawLine(ctx, min * 0.7, min / 2, min, min / 2);
        this.drawLine(ctx, min * 0.3, min * 0.3, min * 0.7, min * 0.3);
        this.drawLine(ctx, min * 0.3, min * 0.3, min * 0.4, min * 0.4);
        this.drawLine(ctx, min * 0.7, min * 0.3, min * 0.6, min * 0.4);
        ctx.stroke();
        ctx.beginPath();
        ctx.rect(min * 0.3, min * 0.4, min * 0.4, min * 0.2);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2128 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        this.drawLine(ctx, 0, min / 2, min * 0.3, min / 2);
        this.drawLine(ctx, min * 0.7, min / 2, min, min / 2);
        ctx.stroke();
        ctx.beginPath();
        ctx.rect(min * 0.3, min * 0.4, min * 0.4, min * 0.2);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2130 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        this.drawLine(ctx, 0, min / 2, min * 0.2, min / 2);
        this.drawLine(ctx, min * 0.2, min * 0.4, min * 0.2, min * 0.6);
        this.drawLine(ctx, min * 0.3, min * 0.3, min * 0.3, min * 0.7);
        this.drawLine(ctx, min * 0.4, min * 0.4, min * 0.4, min * 0.6);
        this.drawLine(ctx, min * 0.5, min * 0.3, min * 0.5, min * 0.7);
        this.drawLine(ctx, min * 0.6, min * 0.4, min * 0.6, min * 0.6);
        this.drawLine(ctx, min * 0.7, min * 0.3, min * 0.7, min * 0.7);
        this.drawLine(ctx, min * 0.7, min / 2, min, min / 2);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2131 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        this.drawLine(ctx, 0, min / 2, min * 0.4, min / 2);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx, min * 0.6, min * 0.35, min * 0.35, min * 0.65);
        this.drawLine(ctx, min * 0.6, min * 0.35, min * 0.65, min * 0.4);
        this.drawLine(ctx, min * 0.4, min * 0.35, min * 0.4, min * 0.65);
        this.drawLine(ctx, min * 0.5, min * 0.35, min * 0.5, min * 0.65);
        this.drawLine(ctx, min * 0.5, min / 2, min, min / 2);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2132 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        this.drawLine(ctx, 0, min / 2, min * 0.4, min / 2);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx, min * 0.35, min * 0.3, min * 0.4, min * 0.35);
        this.drawLine(ctx, min * 0.4, min * 0.35, min * 0.4, min * 0.7);
        this.drawLine(ctx, min * 0.5, min * 0.3, min * 0.5, min * 0.7);
        this.drawLine(ctx, min * 0.5, min / 2, min, min / 2);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2133 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        this.drawLine(ctx, 0, min / 2, min * 0.4, min / 2);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx, min * 0.4, min * 0.4, min * 0.4, min * 0.6);
        this.drawLine(ctx, min * 0.5, min * 0.3, min * 0.5, min * 0.7);
        this.drawLine(ctx, min * 0.5, min / 2, min, min / 2);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2134 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        this.drawLine(ctx, min * 0.1, min * 0.46, min * 0.3, min * 0.46);
        this.drawLine(ctx, min * 0.1, min * 0.53, min * 0.3, min * 0.53);
        this.drawLine(ctx, min * 0.74, min * 0.5, min * 0.95, min * 0.5);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.72, min * 0.5, min * 0.02, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        ctx.rect(min * 0.3, min * 0.4, min * 0.4, min * 0.2);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2135 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[0];
        ctx.beginPath();
        ctx.arc(min * 0.63, min * 0.5, min * 0.02, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.37, min * 0.5, min * 0.02, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx, 0, min / 2, min * 0.35, min / 2);
        this.drawLine(ctx, min * 0.65, min / 2, min, min / 2);
        this.drawLine(ctx, min * 0.3, min * 0.6, min * 0.7, min * 0.6);
        this.drawLine(ctx, min * 0.5, min * 0.3, min * 0.5, min * 0.6);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2136 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[0];
        ctx.beginPath();
        ctx.arc(min * 0.60, min * 0.5, min * 0.1, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx, min * 0.1, min * 0.5, min * 0.5, min / 2);
        this.drawLine(ctx, min * 0.5, min * 0.4, min * 0.53, min * 0.43);
        this.drawLine(ctx, min * 0.1, min * 0.4, min * 0.5, min * 0.4);
        this.drawLine(ctx, min * 0.1, min * 0.6, min * 0.5, min * 0.6);
        this.drawLine(ctx, min * 0.5, min * 0.6, min * 0.53, min * 0.57);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2137 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[0];
        ctx.beginPath();
        ctx.arc(min * 0.60, min * 0.5, min * 0.2, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx, min * 0.1, min * 0.5, min * 0.5, min / 2);
        this.drawLine(ctx, min * 0.5, min * 0.35, min * 0.5, min * 0.65);
        this.drawLine(ctx, min * 0.5, min * 0.5, min * 0.7, min * 0.35);
        this.drawLine(ctx, min * 0.5, min * 0.5, min * 0.65, min * 0.6);
        this.drawLine(ctx, min * 0.7, min * 0.95, min * 0.7, min * 0.65);
        this.drawLine(ctx, min * 0.7, min * 0.05, min * 0.7, min * 0.35);
        ctx.stroke();
        let x = min * 0.7,
            y = min * 0.65,
            r = min * 0.08;
        ctx.moveTo(x, y - r); //从A（100,0）开始
        ctx.lineTo(x, y); //从A(100,0)开始，画到B (0,173)结束
        ctx.lineTo(x - r, y); //B(0,173)-C(200,173)
        ctx.closePath();
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2138 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[0];
        let x = min * 0.25,
            y = min * 0.3,
            r = min * 0.08;
        ctx.moveTo(x, y + r); //从A（100,0）开始
        ctx.lineTo(x, y); //从A(100,0)开始，画到B (0,173)结束
        ctx.lineTo(x + r, y); //B(0,173)-C(200,173)
        ctx.closePath();
        ctx.stroke();
        ctx.beginPath();

        ctx.arc(min * 0.75, min * 0.5, min * 0.25, 0.75 * Math.PI, 1.25 * Math.PI);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx, 0, min / 2, min * 0.4, min / 2);
        this.drawLine(ctx, min * 0.4, min * 0.3, min * 0.4, min * 0.7);
        this.drawLine(ctx, min * 0.5, min / 2, min, min / 2);
        this.drawLine(ctx, min * 0.3, min * 0.35, min * 0.65, min * 0.7);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2139 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[0];
        let x = min * 0.7,
            y = min * 0.32,
            r = min * 0.08;
        ctx.moveTo(x - r, y); //从A（100,0）开始
        ctx.lineTo(x, y); //从A(100,0)开始，画到B (0,173)结束
        ctx.lineTo(x, y + r); //B(0,173)-C(200,173)
        ctx.closePath();
        ctx.stroke();
        ctx.beginPath();

        ctx.arc(min * 0.75, min * 0.5, min * 0.25, 0.75 * Math.PI, 1.25 * Math.PI);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx, 0, min / 2, min * 0.4, min / 2);
        this.drawLine(ctx, min * 0.4, min * 0.3, min * 0.4, min * 0.7);
        this.drawLine(ctx, min * 0.5, min / 2, min, min / 2);
        this.drawLine(ctx, min * 0.3, min * 0.7, min * 0.65, min * 0.35);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2140 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        ctx.arc(min * 0.75, min * 0.5, min * 0.25, 0.75 * Math.PI, 1.25 * Math.PI);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx, 0, min / 2, min * 0.4, min / 2);
        this.drawLine(ctx, min * 0.3, min * 0.3, min * 0.3, min * 0.4);
        this.drawLine(ctx, min * 0.25, min * 0.35, min * 0.35, min * 0.35);
        this.drawLine(ctx, min * 0.4, min * 0.3, min * 0.4, min * 0.7);
        this.drawLine(ctx, min * 0.6, min * 0.35, min * 0.7, min * 0.35);
        this.drawLine(ctx, min * 0.5, min / 2, min, min / 2);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2141 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        this.drawLine(ctx, 0, min / 2, min * 0.4, min / 2);
        this.drawLine(ctx, min * 0.3, min * 0.3, min * 0.3, min * 0.4);
        this.drawLine(ctx, min * 0.25, min * 0.35, min * 0.35, min * 0.35);
        this.drawLine(ctx, min * 0.4, min * 0.3, min * 0.4, min * 0.7);
        this.drawLine(ctx, min * 0.55, min * 0.35, min * 0.65, min * 0.35);
        this.drawLine(ctx, min * 0.5, min * 0.4, min * 0.5, min * 0.6);
        this.drawLine(ctx, min * 0.5, min / 2, min, min / 2);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2142 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx, min * 0.2, min * 0.5, min * 0.8, min * 0.5);
        this.drawLine(ctx, min * 0.5, min * 0.2, min * 0.5, min * 0.5);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.2, min * 0.55, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.8, min * 0.55, min * 0.05, 0, Math.PI * 2, false);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2144 (ctx) {
        //canvas高度和宽度
         var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx, min * 0.5, min * 0.1, min * 0.5, min * 0.9);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.5, min * 0.3, min * 0.1, 0, Math.PI * 2, false);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.5, min * 0.7, min * 0.1, 0, Math.PI * 2, false);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }

    /** */
    draw2201 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx, min * 0.5, min * 0.47, min * 0.75, min * 0.47);
        this.drawLine(ctx, min * 0.3, min * 0.4, min * 0.3, min * 0.25);
        this.drawLine(ctx, min * 0.6, min * 0.4, min * 0.6, min * 0.25);
        this.drawLine(ctx, min * 0.9, min * 0.4, min * 0.9, min * 0.25);
        this.drawLine(ctx, min * 0.3, min * 0.55, min * 0.3, min * 0.7);
        this.drawLine(ctx, min * 0.75, min * 0.4, min * 0.75, min * 0.55);
        this.drawLine(ctx, min * 0.75, min * 0.6, min * 0.75, min * 0.75);
        ctx.stroke();
        ctx.beginPath();
        ctx.rect(min * 0.1, min * 0.4, min * 0.4, min * 0.15);
        ctx.stroke();
        ctx.fillRect(min * 0.1, min * 0.4, min * 0.11, min * 0.15);
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2202 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx, min * 0.5, min * 0.3, min * 0.5, min * 0.1);
        this.drawLine(ctx, min * 0.1, min * 0.7, min * 0.3, min * 0.3);
        this.drawLine(ctx, min * 0.5, min * 0.7, min * 0.5, min * 0.9);
        ctx.stroke();
        ctx.beginPath();
        ctx.rect(min * 0.1, min * 0.3, min * 0.8, min * 0.4);
        ctx.rect(min * 0.1, min * 0.3, min * 0.2, min * 0.4);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2203 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx, min * 0.5, min * 0.3, min * 0.5, min * 0.1);
        this.drawLine(ctx, min * 0.15, min * 0.6, min * 0.25, min * 0.4);
        this.drawLine(ctx, min * 0.5, min * 0.7, min * 0.5, min * 0.9);
        this.drawLine(ctx, min * 0.15, min * 0.6, min * 0.1, min * 0.6);
        this.drawLine(ctx, min * 0.3, min * 0.4, min * 0.25, min * 0.4);
        ctx.stroke();
        ctx.beginPath();
        ctx.rect(min * 0.1, min * 0.3, min * 0.8, min * 0.4);
        ctx.rect(min * 0.1, min * 0.3, min * 0.2, min * 0.4);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2204 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx, min * 0.5, min * 0.4, min * 0.5, min * 0.1);
        this.drawLine(ctx, min * 0.5, min * 0.6, min * 0.5, min * 0.9);
        this.drawLine(ctx, min * 0.5, min * 0.6, min * 0.6, min * 0.6);
        this.drawLine(ctx, min * 0.5, min * 0.4, min * 0.6, min * 0.4);
        this.drawLine(ctx, min * 0.6, min * 0.6, min * 0.6, min * 0.4);
        ctx.stroke();
        ctx.beginPath();
        ctx.rect(min * 0.2, min * 0.3, min * 0.6, min * 0.4);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2205 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx, min * 0.5, min * 0.3, min * 0.5, min * 0.1);
        this.drawLine(ctx, min * 0.5, min * 0.7, min * 0.5, min * 0.9);
        this.drawLine(ctx, min * 0.5, min * 0.4, min * 0.5, min * 0.6);
        this.drawLine(ctx, min * 0.3, min * 0.5, min * 0.5, min * 0.5);
        this.drawLine(ctx, min * 0.5, min * 0.48, min * 0.6, min * 0.4);
        this.drawLine(ctx, min * 0.5, min * 0.52, min * 0.6, min * 0.6);
        ctx.stroke();
        ctx.beginPath();
        ctx.rect(min * 0.2, min * 0.3, min * 0.6, min * 0.4);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2206 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx, min * 0.1, min * 0.5, min * 0.9, min * 0.5);
        this.drawLine(ctx, min * 0.1, min * 0.45, min * 0.1, min * 0.55);
        this.drawLine(ctx, min * 0.9, min * 0.45, min * 0.9, min * 0.55);
        this.drawLine(ctx, min * 0.4, min * 0.4, min * 0.6, min * 0.6);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2207 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        ctx.strokeText("Q", min * 0.5, min * 0.2);
        ctx.strokeText("1 Mvar", min * 0.5, min * 0.4);
        ctx.strokeText("5|10s", min * 0.5, min * 0.8);
        this.drawLine(ctx, min * 0.7, min * 0.2, min * 0.65, min * 0.17);
        this.drawLine(ctx, min * 0.7, min * 0.2, min * 0.65, min * 0.23);
        this.drawLine(ctx, min * 0.35, min * 0.3, min * 0.65, min * 0.3);
        this.drawLine(ctx, min * 0.35, min * 0.28, min * 0.35, min * 0.32);
        this.drawLine(ctx, min * 0.5, min * 0.3, min * 0.52, min * 0.28);
        this.drawLine(ctx, min * 0.5, min * 0.3, min * 0.52, min * 0.32);
        this.drawLine(ctx, min * 0.35, min * 0.7, min * 0.65, min * 0.7);
        this.drawLine(ctx, min * 0.35, min * 0.68, min * 0.35, min * 0.72);
        this.drawLine(ctx, min * 0.65, min * 0.68, min * 0.65, min * 0.72);
        this.drawLine(ctx, min * 0.65, min * 0.68, min * 0.65, min * 0.72);
        this.drawLine(ctx, min * 0.4, min * 0.78, min * 0.6, min * 0.62);
        ctx.stroke();
        ctx.beginPath();
        ctx.rect(min * 0.3, min * 0.1, min * 0.4, min * 0.8);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2208 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];
        ctx.beginPath();
        ctx.arc(min * 0.5, min * 0.6, min * 0.1, Math.PI, 2 * Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.3, min * 0.6, min * 0.1, Math.PI, 2 * Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.7, min * 0.6, min * 0.1, Math.PI, 2 * Math.PI);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx, min * 0.56, min * 0.4, min * 0.36, min * 0.7);
        this.drawLine(ctx, min * 0.64, min * 0.4, min * 0.44, min * 0.7);
        ctx.stroke();
        ctx.beginPath();
        ctx.rect(min * 0.1, min * 0.3, min * 0.8, min * 0.5);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2209 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx, min * 0.5, min * 0.15, min * 0.5, min * 0.25);
        this.drawLine(ctx, min * 0.7, min * 0.2, min * 0.65, min * 0.17);
        this.drawLine(ctx, min * 0.7, min * 0.2, min * 0.65, min * 0.23);
        ctx.strokeText("5X", min * 0.6, min * 0.5);
        this.drawLine(ctx, min * 0.1, min * 0.3, min * 0.25, min * 0.3);
        this.drawLine(ctx, min * 0.75, min * 0.5, min * 0.9, min * 0.5);
        this.drawLine(ctx, min * 0.75, min * 0.7, min * 0.9, min * 0.7);
        this.drawLine(ctx, min * 0.35, min * 0.7, min * 0.65, min * 0.7);
        this.drawLine(ctx, min * 0.35, min * 0.68, min * 0.35, min * 0.72);
        this.drawLine(ctx, min * 0.65, min * 0.68, min * 0.65, min * 0.72);
        this.drawLine(ctx, min * 0.65, min * 0.68, min * 0.65, min * 0.72);
        this.drawLine(ctx, min * 0.55, min * 0.75, min * 0.45, min * 0.65);
        ctx.stroke();
        ctx.beginPath();
        ctx.rect(min * 0.25, min * 0.1, min * 0.5, min * 0.8);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2210 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];
        ctx.beginPath();
        ctx.ellipse(min * 0.5, min * 0.3, min * 0.1, min * 0.05, 0, 0, Math.PI * 2);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx, min * 0.5, min * 0.15, min * 0.5, min * 0.25);
        this.drawLine(ctx, min * 0.25, min * 0.5, min * 0.75, min * 0.5);
        this.drawLine(ctx, min * 0.55, min * 0.62, min * 0.7, min * 0.62);
        ctx.stroke();
        ctx.beginPath();
        ctx.rect(min * 0.25, min * 0.1, min * 0.5, min * 0.8);
        ctx.stroke();
        ctx.beginPath();
        ctx.rect(min * 0.42, min * 0.62, min * 0.15, min * 0.15);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2211 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];
        ctx.beginPath();
        ctx.arc(min * 0.3, min * 0.3, min * 0.1, 0, 2 * Math.PI);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx, min * 0.45, min * 0.3, min * 0.65, min * 0.3);
        this.drawLine(ctx, min * 0.75, min * 0.2, min * 0.75, min * 0.4);
        this.drawLine(ctx, min * 0.25, min * 0.7, min * 0.75, min * 0.7);
        this.drawLine(ctx, min * 0.75, min * 0.6, min * 0.75, min * 0.8);
        this.drawLine(ctx, min * 0.25, min * 0.6, min * 0.25, min * 0.8);
        ctx.stroke();
        ctx.beginPath();
        ctx.rect(min * 0.1, min * 0.1, min * 0.8, min * 0.8);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2212 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];

        ctx.save(); //保存状态
        ctx.beginPath();
        var x = min * 0.4,
            y = min * 0.4,
            w = min * 0.2,
            h = min * 0.2,
            // angle =0,
            angle = (Math.PI / 180) * 45,
            rectCenterPoint = {
                x: x + w / 2,
                y: y + h / 2
            }; // 矩形中心点
        ctx.translate(rectCenterPoint.x, rectCenterPoint.y);
        ctx.rotate(angle);
        ctx.translate(-rectCenterPoint.x, -rectCenterPoint.y);
        ctx.rect(x, y, w, h);
        this.drawLine(ctx, x, y + w * 0.2, x + w - w * 0.2, y + h);
        this.drawLine(ctx, x + w * 0.2, y, x + w, y + h - w * 0.2);
        ctx.stroke();
        ctx.restore();
        ctx.beginPath();
        this.drawLine(ctx, min * 0.5, min * 0.1, min * 0.5, min * 0.38);
        this.drawLine(ctx, min * 0.5, min * 0.62, min * 0.5, min * 0.9);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2213 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];

        ctx.save(); //保存状态
        ctx.beginPath();
        var x = min * 0.35,
            y = min * 0.35,
            w = min * 0.1,
            h = min * 0.1,
            // angle =0,
            angle = (Math.PI / 180) * 45,
            rectCenterPoint = {
                x: x + w / 2,
                y: y + h / 2
            }; // 矩形中心点
        ctx.translate(rectCenterPoint.x, rectCenterPoint.y);
        ctx.rotate(angle);
        ctx.translate(-rectCenterPoint.x, -rectCenterPoint.y);
        ctx.rect(x, y, w, h);
        this.drawLine(ctx, x, y + w * 0.2, x + w - w * 0.2, y + h);
        this.drawLine(ctx, x + w * 0.2, y, x + w, y + h - w * 0.2);
        ctx.stroke();
        ctx.restore();
        ctx.beginPath();
        ctx.rect(min * 0.1, min * 0.2, min * 0.6, min * 0.6);
        this.drawLine(ctx, min * 0.7, min * 0.5, min * 0.9, min * 0.5);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2214 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];

        ctx.save(); //保存状态
        ctx.beginPath();
        var x = min * 0.45,
            y = min * 0.35,
            w = min * 0.1,
            h = min * 0.1,
            // angle =0,
            angle = (Math.PI / 180) * 45,
            rectCenterPoint = {
                x: x + w / 2,
                y: y + h / 2
            }; // 矩形中心点
        ctx.translate(rectCenterPoint.x, rectCenterPoint.y);
        ctx.rotate(angle);
        ctx.translate(-rectCenterPoint.x, -rectCenterPoint.y);
        ctx.rect(x, y, w, h);
        this.drawLine(ctx, x, y + w * 0.2, x + w - w * 0.2, y + h);
        this.drawLine(ctx, x + w * 0.2, y, x + w, y + h - w * 0.2);
        ctx.stroke();
        ctx.restore();
        ctx.beginPath();
        ctx.rect(min * 0.25, min * 0.25, min * 0.5, min * 0.5);
        this.drawLine(ctx, min * 0.75, min * 0.5, min * 0.9, min * 0.5);
        this.drawLine(ctx, min * 0.52, min * 0.6, min * 0.65, min * 0.6);
        this.drawLine(ctx, min * 0.35, min * 0.6, min * 0.48, min * 0.6);
        this.drawLine(ctx, min * 0.48, min * 0.55, min * 0.48, min * 0.65);
        this.drawLine(ctx, min * 0.52, min * 0.55, min * 0.52, min * 0.65);
        ctx.rect(min * 0.1, min * 0.4, min * 0.1, min * 0.2);
        this.drawLine(ctx, min * 0.1, min * 0.42, min * 0.2, min * 0.52);
        this.drawLine(ctx, min * 0.1, min * 0.49, min * 0.2, min * 0.59);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2215 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];

        ctx.save(); //保存状态
        ctx.beginPath();
        var x = min * 0.3,
            y = min * 0.45,
            w = min * 0.1,
            h = min * 0.1,
            // angle =0,
            angle = (Math.PI / 180) * 45,
            rectCenterPoint = {
                x: x + w / 2,
                y: y + h / 2
            }; // 矩形中心点
        ctx.translate(rectCenterPoint.x, rectCenterPoint.y);
        ctx.rotate(angle);
        ctx.translate(-rectCenterPoint.x, -rectCenterPoint.y);
        ctx.rect(x, y, w, h);
        this.drawLine(ctx, x, y + w * 0.2, x + w - w * 0.2, y + h);
        this.drawLine(ctx, x + w * 0.2, y, x + w, y + h - w * 0.2);
        ctx.stroke();
        ctx.restore();
        ctx.beginPath();
        this.drawLine(ctx, min * 0.4, min * 0.5, min * 0.7, min * 0.5);
        this.drawLine(ctx, min * 0.28, min * 0.45, min * 0.28, min * 0.55);
        this.drawLine(ctx, min * 0.35, min * 0.2, min * 0.35, min * 0.42);
        this.drawLine(ctx, min * 0.35, min * 0.57, min * 0.35, min * 0.8);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2216 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];

        ctx.save(); //保存状态
        ctx.beginPath();
        var x = min * 0.3,
            y = min * 0.45,
            w = min * 0.1,
            h = min * 0.1,
            // angle =0,
            angle = (Math.PI / 180) * 45,
            rectCenterPoint = {
                x: x + w / 2,
                y: y + h / 2
            }; // 矩形中心点
        ctx.translate(rectCenterPoint.x, rectCenterPoint.y);
        ctx.rotate(angle);
        ctx.translate(-rectCenterPoint.x, -rectCenterPoint.y);
        ctx.rect(x, y, w, h);
        this.drawLine(ctx, x, y + w * 0.2, x + w - w * 0.2, y + h);
        this.drawLine(ctx, x + w * 0.2, y, x + w, y + h - w * 0.2);
        ctx.stroke();
        ctx.restore();
        if (this.value == 1) {
            ctx.beginPath();
            this.drawLine(ctx, min * 0.6, min * 0.57, min * 0.6, min * 0.4);
            this.drawLine(ctx, min * 0.4, min * 0.5, min * 0.6, min * 0.5);
            ctx.stroke();

        } else {
            ctx.beginPath();
            this.drawLine(ctx, min * 0.6, min * 0.57, min * 0.52, min * 0.4);
            this.drawLine(ctx, min * 0.4, min * 0.5, min * 0.57, min * 0.5);
            ctx.stroke();
        }
        ctx.beginPath();
        this.drawLine(ctx, min * 0.28, min * 0.45, min * 0.28, min * 0.55);
        this.drawLine(ctx, min * 0.6, min * 0.2, min * 0.6, min * 0.42);
        this.drawLine(ctx, min * 0.6, min * 0.57, min * 0.6, min * 0.8);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2217 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];

        ctx.save(); //保存状态
        ctx.beginPath();
        var x = min * 0.3,
            y = min * 0.45,
            w = min * 0.1,
            h = min * 0.1,
            // angle =0,
            angle = (Math.PI / 180) * 45,
            rectCenterPoint = {
                x: x + w / 2,
                y: y + h / 2
            }; // 矩形中心点
        ctx.translate(rectCenterPoint.x, rectCenterPoint.y);
        ctx.rotate(angle);
        ctx.translate(-rectCenterPoint.x, -rectCenterPoint.y);
        ctx.rect(x, y, w, h);
        this.drawLine(ctx, x, y + w * 0.2, x + w - w * 0.2, y + h);
        this.drawLine(ctx, x + w * 0.2, y, x + w, y + h - w * 0.2);
        ctx.stroke();
        ctx.restore();
        if (this.value == 1) {
            ctx.beginPath();
            this.drawLine(ctx, min * 0.6, min * 0.57, min * 0.6, min * 0.4);
            this.drawLine(ctx, min * 0.4, min * 0.5, min * 0.6, min * 0.5);
            ctx.stroke();

        } else {
            ctx.beginPath();
            this.drawLine(ctx, min * 0.6, min * 0.57, min * 0.52, min * 0.4);
            this.drawLine(ctx, min * 0.4, min * 0.5, min * 0.57, min * 0.5);
            ctx.stroke();
        }
        ctx.beginPath();
        this.drawLine(ctx, min * 0.6, min * 0.2, min * 0.6, min * 0.42);
        this.drawLine(ctx, min * 0.6, min * 0.57, min * 0.6, min * 0.8);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2218 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];

        ctx.save(); //保存状态
        ctx.beginPath();
        var x = min * 0.3,
            y = min * 0.45,
            w = min * 0.1,
            h = min * 0.1,
            // angle =0,
            angle = (Math.PI / 180) * 45,
            rectCenterPoint = {
                x: x + w / 2,
                y: y + h / 2
            }; // 矩形中心点
        ctx.translate(rectCenterPoint.x, rectCenterPoint.y);
        ctx.rotate(angle);
        ctx.translate(-rectCenterPoint.x, -rectCenterPoint.y);
        ctx.rect(x, y, w, h);
        this.drawLine(ctx, x, y + w * 0.2, x + w - w * 0.2, y + h);
        this.drawLine(ctx, x + w * 0.2, y, x + w, y + h - w * 0.2);
        ctx.stroke();
        ctx.restore();
        if (this.value == 1) {
            ctx.beginPath();
            this.drawLine(ctx, min * 0.6, min * 0.57, min * 0.6, min * 0.4);
            this.drawLine(ctx, min * 0.4, min * 0.5, min * 0.6, min * 0.5);
            ctx.stroke();

        } else {
            ctx.beginPath();
            this.drawLine(ctx, min * 0.6, min * 0.57, min * 0.52, min * 0.4);
            this.drawLine(ctx, min * 0.4, min * 0.5, min * 0.57, min * 0.5);
            ctx.stroke();
        }
        ctx.beginPath();
        ctx.fillRect(min * 0.2, min * 0.4, min * 0.03, min * 0.2);
        ctx.fillRect(min * 0.23, min * 0.4, min * 0.03, min * 0.03);
        ctx.fillRect(min * 0.23, min * 0.57, min * 0.03, min * 0.03);
        this.drawLine(ctx, min * 0.6, min * 0.2, min * 0.6, min * 0.42);
        this.drawLine(ctx, min * 0.6, min * 0.57, min * 0.6, min * 0.8);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2219 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];

        ctx.save(); //保存状态
        ctx.beginPath();
        var x = min * 0.3,
            y = min * 0.45,
            w = min * 0.1,
            h = min * 0.1,
            // angle =0,
            angle = (Math.PI / 180) * 45,
            rectCenterPoint = {
                x: x + w / 2,
                y: y + h / 2
            }; // 矩形中心点
        ctx.translate(rectCenterPoint.x, rectCenterPoint.y);
        ctx.rotate(angle);
        ctx.translate(-rectCenterPoint.x, -rectCenterPoint.y);
        ctx.rect(x, y, w, h);
        this.drawLine(ctx, x, y + w * 0.2, x + w - w * 0.2, y + h);
        this.drawLine(ctx, x + w * 0.2, y, x + w, y + h - w * 0.2);
        ctx.stroke();
        ctx.restore();
        if (this.value == 1) {
            ctx.beginPath();
            this.drawLine(ctx, min * 0.6, min * 0.57, min * 0.6, min * 0.4);
            this.drawLine(ctx, min * 0.4, min * 0.5, min * 0.6, min * 0.5);
            ctx.stroke();

        } else {
            ctx.beginPath();
            this.drawLine(ctx, min * 0.6, min * 0.57, min * 0.52, min * 0.4);
            this.drawLine(ctx, min * 0.4, min * 0.5, min * 0.57, min * 0.5);
            ctx.stroke();
        }
        ctx.beginPath();
        ctx.strokeText("Fe", min * 0.15, min * 0.5);
        this.drawLine(ctx, min * 0.6, min * 0.2, min * 0.6, min * 0.42);
        this.drawLine(ctx, min * 0.6, min * 0.57, min * 0.6, min * 0.8);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2220 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];
        ctx.beginPath();
        ctx.rect(min * 0.45, min * 0.2, min * 0.1, min * 0.6);
        this.drawLine(ctx, min * 0.5, 0, min * 0.5, min);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2221 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];
        ctx.beginPath();
        ctx.fillRect(min * 0.45, min * 0.2, min * 0.1, min * 0.05);
        ctx.rect(min * 0.45, min * 0.2, min * 0.1, min * 0.6);
        this.drawLine(ctx, min * 0.5, 0, min * 0.5, min);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2222 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];
        ctx.beginPath();
        ctx.rect(min * 0.2, min * 0.2, min * 0.1, min * 0.6);
        this.drawLine(ctx, min * 0.25, 0, min * 0.25, min);
        this.drawLine(ctx, min * 0.3, min * 0.5, min * 0.4, min * 0.5);
        this.drawLine(ctx, min * 0.45, min * 0.5, min * 0.6, min * 0.5);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2223 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];
        ctx.beginPath();
        if (this.value == 1) {
            ctx.beginPath();
            this.drawLine(ctx, min * 0.8, min * 0.6, min * 0.8, min * 0.4);
            this.drawLine(ctx, min * 0.45, min * 0.5, min * 0.8, min * 0.5);
            ctx.stroke();

        } else {
            ctx.beginPath();
            this.drawLine(ctx, min * 0.8, min * 0.6, min * 0.72, min * 0.4);
            this.drawLine(ctx, min * 0.45, min * 0.5, min * 0.75, min * 0.5);
            ctx.stroke();
        }
        ctx.rect(min * 0.2, min * 0.2, min * 0.1, min * 0.6);
        this.drawLine(ctx, min * 0.25, 0, min * 0.25, min);
        this.drawLine(ctx, min * 0.3, min * 0.5, min * 0.4, min * 0.5);
        this.drawLine(ctx, min * 0.3, min * 0.8, min * 0.8, min * 0.8);
        this.drawLine(ctx, min * 0.8, min * 0.1, min * 0.8, min * 0.4);
        this.drawLine(ctx, min * 0.8, min * 0.6, min * 0.8, min * 0.8);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2224 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];
        ctx.beginPath();
        if (this.value == 1) {
            ctx.beginPath();
            this.drawLine(ctx, min * 0.8, min * 0.6, min * 0.8, min * 0.4);
            this.drawLine(ctx, min * 0.3, min * 0.5, min * 0.8, min * 0.5);
            ctx.stroke();

        } else {
            ctx.beginPath();
            this.drawLine(ctx, min * 0.8, min * 0.6, min * 0.72, min * 0.4);
            this.drawLine(ctx, min * 0.3, min * 0.5, min * 0.75, min * 0.5);
            ctx.stroke();
        }
        ctx.rect(min * 0.2, min * 0.2, min * 0.1, min * 0.6);
        this.drawLine(ctx, min * 0.25, 0, min * 0.25, min);
        this.drawLine(ctx, min * 0.8, min * 0.1, min * 0.8, min * 0.4);
        this.drawLine(ctx, min * 0.8, min * 0.6, min * 0.8, min * 0.9);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2225 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];
        ctx.beginPath();
        let x = min * 0.1,
            y = min * 0.2,
            w = min * 0.1,
            h = min * 0.2;
        for (let i = 2; i < 9; i += 3) {
            let xn = x * i;
            ctx.rect(xn, y, w, h);
            this.drawLine(ctx, xn + min * 0.05, min * 0.1, xn + min * 0.05, min * 0.6);
            this.drawLine(ctx, xn + min * 0.1, y + min * 0.1, xn + min * 0.2, y + min * 0.1);
            this.drawLine(ctx, xn + min * 0.05, min * 0.7, xn + min * 0.05, min * 0.9);
            if (this.value == 1) {
                this.drawLine(ctx, xn + min * 0.05, min * 0.7, xn + min * 0.05, min * 0.6);
            } else {
                this.drawLine(ctx, xn + min * 0.05, min * 0.7, xn, min * 0.6);
            }
            this.drawLine(ctx, xn + min * 0.2, min * 0.3, xn + min * 0.2, min * 0.45);
        }
        this.drawLine(ctx, min * 0.2, min * 0.65, min, min * 0.65);
        this.drawLine(ctx, min * 0.4, min * 0.45, min, min * 0.45);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2226 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];
        ctx.save();
        var angle = -(Math.PI / 180) * 30,
            rectCenterPoint = {
                x: min * 0.5,
                y: min * 0.7
            }; // 矩形中心点

        if (this.value == 0) {
            ctx.translate(rectCenterPoint.x, rectCenterPoint.y);
            ctx.rotate(angle);
            ctx.translate(-rectCenterPoint.x, -rectCenterPoint.y);
        }
        ctx.beginPath();
        ctx.rect(min * 0.47, min * 0.45, min * 0.06, min * 0.25);
        ctx.stroke();
        this.drawLine(ctx, min * 0.5, min * 0.7, min * 0.5, min * 0.4);
        ctx.stroke();
        ctx.restore();
        ctx.beginPath();
        ctx.arc(min * 0.5, min * 0.38, min * 0.02, 0, 2 * Math.PI);
        this.drawLine(ctx, min * 0.45, min * 0.35, min * 0.55, min * 0.35);
        this.drawLine(ctx, min * 0.5, 0, min * 0.5, min * 0.35);
        this.drawLine(ctx, min * 0.5, min * 0.7, min * 0.5, min);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2227 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];
        ctx.beginPath();
        let s = min * 0.08;
        var h = s * Math.sin(Math.PI / 3); //计算等边三角形的高
        let point1 = {
            x: min * 0.5,
            y: min * 0.6
        }
        ctx.moveTo(point1.x, point1.y);
        ctx.lineTo(point1.x - s / 2, point1.y + h);
        ctx.lineTo(point1.x + s / 2, point1.y + h);
        ctx.fillStyle = this.switchColor[0];
        ctx.fill();
        let point2 = {
            x: min * 0.5,
            y: min * 0.4
        }
        ctx.moveTo(point2.x, point2.y);
        ctx.lineTo(point2.x - s / 2, point2.y - h);
        ctx.lineTo(point2.x + s / 2, point2.y - h);
        ctx.fillStyle = this.switchColor[1];
        ctx.fill();
        ctx.beginPath();
        this.drawLine(ctx, min * 0.5, min * 0.65, min * 0.5, min);
        this.drawLine(ctx, min * 0.5, min * 0.35, min * 0.5, 0);
        this.drawLine(ctx, min * 0.3, min * 0.5, min * 0.7, min * 0.5);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2228 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];
        ctx.beginPath();
        let s = min * 0.08;
        var h = s * Math.sin(Math.PI / 3); //计算等边三角形的高
        let point2 = {
            x: min * 0.5,
            y: min * 0.4
        }
        ctx.moveTo(point2.x, point2.y);
        ctx.lineTo(point2.x - s / 2, point2.y - h);
        ctx.lineTo(point2.x + s / 2, point2.y - h);
        ctx.fillStyle = this.switchColor[1];
        ctx.fill();
        ctx.beginPath();
        ctx.rect(min * 0.45, min * 0.2, min * 0.1, min * 0.4);
        this.drawLine(ctx, min * 0.5, min * 0.6, min * 0.5, min);
        this.drawLine(ctx, min * 0.5, min * 0.35, min * 0.5, 0);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2229 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];
        ctx.beginPath();
        let s = min * 0.08;
        var h = s * Math.sin(Math.PI / 3); //计算等边三角形的高
        let point1 = {
            x: min * 0.5,
            y: min * 0.55
        }
        ctx.moveTo(point1.x, point1.y);
        ctx.lineTo(point1.x - s / 2, point1.y + h);
        ctx.lineTo(point1.x + s / 2, point1.y + h);
        ctx.fillStyle = this.switchColor[0];
        ctx.fill();
        let point2 = {
            x: min * 0.5,
            y: min * 0.45
        }
        ctx.moveTo(point2.x, point2.y);
        ctx.lineTo(point2.x - s / 2, point2.y - h);
        ctx.lineTo(point2.x + s / 2, point2.y - h);
        ctx.fillStyle = this.switchColor[1];
        ctx.fill();
        ctx.beginPath();
        this.drawLine(ctx, min * 0.5, min * 0.6, min * 0.5, min);
        this.drawLine(ctx, min * 0.5, min * 0.4, min * 0.5, 0);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.5, min * 0.5, min * 0.25, 0, 2 * Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.6, min * 0.6, min * 0.02, 0, 2 * Math.PI);
        ctx.fill();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2230 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];
        ctx.beginPath();
        let s = min * 0.08;
        var h = s * Math.sin(Math.PI / 3); //计算等边三角形的高
        let point1 = {
            x: min * 0.5,
            y: min * 0.55
        }
        ctx.moveTo(point1.x, point1.y);
        ctx.lineTo(point1.x - s / 2, point1.y + h);
        ctx.lineTo(point1.x + s / 2, point1.y + h);
        ctx.fillStyle = this.switchColor[0];
        ctx.fill();
        let point2 = {
            x: min * 0.5,
            y: min * 0.45
        }
        ctx.moveTo(point2.x, point2.y);
        ctx.lineTo(point2.x - s / 2, point2.y - h);
        ctx.lineTo(point2.x + s / 2, point2.y - h);
        ctx.fillStyle = this.switchColor[1];
        ctx.fill();
        ctx.beginPath();
        this.drawLine(ctx, min * 0.5, min * 0.6, min * 0.5, min);
        this.drawLine(ctx, min * 0.5, min * 0.4, min * 0.5, 0);
        this.drawLine(ctx, min * 0.1, min * 0.5, min * 0.55, min * 0.5);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.5, min * 0.5, min * 0.25, 0, 2 * Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min * 0.6, min * 0.6, min * 0.02, 0, 2 * Math.PI);
        ctx.fill();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2231 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];
        ctx.save();
        var angle = -(Math.PI / 180) * 30,
            rectCenterPoint = {
                x: min * 0.5,
                y: min * 0.7
            }; // 矩形中心点

        if (this.value == 0) {
            ctx.translate(rectCenterPoint.x, rectCenterPoint.y);
            ctx.rotate(angle);
            ctx.translate(-rectCenterPoint.x, -rectCenterPoint.y);
        }
        ctx.beginPath();

        this.drawLine(ctx, min * 0.5, min * 0.7, min * 0.5, min * 0.4);
        ctx.stroke();
        ctx.restore();
        ctx.beginPath();
        ctx.arc(min * 0.5, min * 0.35, min * 0.04, 0.5 * Math.PI, 1.5 * Math.PI);
        this.drawLine(ctx, min * 0.4, min * 0.7, min * 0.6, min * 0.7);
        this.drawLine(ctx, min * 0.5, 0, min * 0.5, min * 0.4);
        this.drawLine(ctx, min * 0.5, min * 0.7, min * 0.5, min);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2232 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        
        ctx.beginPath();
        this.drawLine(ctx, min * 0.6, min * 0.6, min * 0.8, min * 0.6);
        this.drawLine(ctx, min * 0.7, 0, min * 0.7, min * 0.3);
        this.drawLine(ctx, min * 0.7, min * 0.6, min * 0.7, min);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2233 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];
        ctx.beginPath();
        this.drawLine(ctx, min * 0.85, min * 0.6, min * 0.95, min * 0.6);
        this.drawLine(ctx, min * 0.9, min * 0.1, min * 0.9, min * 0.4);
        this.drawLine(ctx, min * 0.9, min * 0.6, min * 0.9, min * 0.9);
        ctx.stroke();
        ctx.beginPath();
        ctx.rect(min * 0.1, min * 0.4, min * 0.4, min * 0.2);
        if (this.value == 0) {
            this.drawLine(ctx, min * 0.5, min * 0.5, min * 0.85, min * 0.5);
        } else {
            this.drawLine(ctx, min * 0.5, min * 0.5, min * 0.9, min * 0.5);
        }

        this.drawLine(ctx, min * 0.3, min * 0.1, min * 0.3, min * 0.4);
        this.drawLine(ctx, min * 0.3, min * 0.6, min * 0.3, min * 0.9);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2236 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];
        ctx.beginPath();
        this.drawLine(ctx, min * 0.85, min * 0.6, min * 0.95, min * 0.6);
        this.drawLine(ctx, min * 0.9, min * 0.1, min * 0.9, min * 0.4);
        this.drawLine(ctx, min * 0.9, min * 0.6, min * 0.9, min * 0.9);
        ctx.stroke();
        ctx.beginPath();
        ctx.rect(min * 0.1, min * 0.4, min * 0.4, min * 0.2);
        if (this.value == 0) {
            this.drawLine(ctx, min * 0.5, min * 0.5, min * 0.85, min * 0.5);
        } else {
            this.drawLine(ctx, min * 0.5, min * 0.5, min * 0.9, min * 0.5);
        }

        this.drawLine(ctx, min * 0.3, min * 0.1, min * 0.3, min * 0.4);
        this.drawLine(ctx, min * 0.3, min * 0.6, min * 0.3, min * 0.9);
        ctx.stroke();
        ctx.beginPath();
        this.drawLine(ctx, min * 0.2, min * 0.5, min * 0.3, min * 0.5);
        this.drawLine(ctx, min * 0.3, min * 0.48, min * 0.4, min * 0.45);
        this.drawLine(ctx, min * 0.3, min * 0.52, min * 0.4, min * 0.55);
        this.drawLine(ctx, min * 0.3, min * 0.45, min * 0.3, min * 0.55);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2237 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];
        ctx.fillStyle = this.switchColor[1];
        ctx.rect(min * 0.2, min * 0.1, min * 0.6, min * 0.8);
        ctx.strokeText("X", min * 0.3, min * 0.3);
        ctx.strokeText("Y", min * 0.7, min * 0.3);
        this.drawLine(ctx, min * 0.55, min * 0.2, min * 0.45, min * 0.4);
        this.drawLine(ctx, min * 0.6, min * 0.2, min * 0.5, min * 0.4);
        ctx.stroke();

        ctx.beginPath();
        ctx.arc(min * 0.5, min * 0.5, min * 0.04, 0, 2 * Math.PI);
        ctx.fill();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2238 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        //min为绘制canvas的宽度(高度)
        function drawTriangle(point, s, direction) {
            //顶点，边长，方向
            var h = s * Math.sin(Math.PI / 3); //计算等边三角形的高
            let d = direction > 0 ? point.x + h : point.x - h;
            ctx.beginPath();
            ctx.moveTo(point.x, point.y);
            ctx.lineTo(d, point.y - s / 2);
            ctx.lineTo(d, point.y + s / 2);
            ctx.closePath(); //闭合路径
            ctx.fill();
        }
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];
        ctx.fillStyle = this.switchColor[1];

        ctx.rect(min * 0.2, min * 0.1, min * 0.6, min * 0.8);
        this.drawLine(ctx, min * 0.55, min * 0.2, min * 0.45, min * 0.4);
        this.drawLine(ctx, min * 0.6, min * 0.2, min * 0.5, min * 0.4);
        this.drawLine(ctx, min * 0.3, min * 0.55, min * 0.65, min * 0.55);
        this.drawLine(ctx, min * 0.3, min * 0.65, min * 0.65, min * 0.65);
        ctx.stroke();
        let s = 0.08 * min,
            direction = -1;
        drawTriangle({
            x: min * 0.7,
            y: min * 0.55
        }, s, direction)
        drawTriangle({
            x: min * 0.7,
            y: min * 0.65
        }, s, direction)
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2240 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        //min为绘制canvas的宽度(高度)
        
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];
        
        ctx.beginPath();
        ctx.font = "22px Serif";
        ctx.strokeText("∮", min * 0.4, min * 0.3);
        this.drawLine(ctx, min * 0.1, min * 0.7, min * 0.4, min * 0.7);
        this.drawLine(ctx, min * 0.6, min * 0.7, min * 0.9, min * 0.7);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2241 (ctx){
        //canvas高度和宽度
        var width = this.width;var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI / 180) * this.rotate);
        ctx.translate(-min / 2, -min / 2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        //min为绘制canvas的宽度(高度)
        
        ctx.lineWidth = this.lineWight;
        ctx.strokeStyle = this.switchColor[1];
        ctx.fillStyle = this.switchColor[1];
        
        ctx.beginPath();
        this.drawLine(ctx, min * 0.5, min * 0.4, min * 0.7, min * 0.4);
        this.drawLine(ctx, min * 0.5, min * 0.1, min * 0.5, min * 0.4);
        this.drawLine(ctx, min * 0.5, min * 0.6, min * 0.5, min * 0.9);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3204 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle=this.switchColor[0];
        ctx.arc(min/2, min/2,  min * 0.8/2, 0, Math.PI * 2, true);
        ctx.stroke();
        ctx.strokeStyle=this.switchColor[1];
        this.drawLine(ctx,min * 0.2,min/2,min * 0.7,min/2);
        this.drawLine(ctx,min * 0.6,min * 0.4,min * 0.7,min/2);
        this.drawLine(ctx,min * 0.6,min * 0.6,min * 0.7,min/2);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }    
    draw3205 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.drawLine(ctx,min * 0.05, min * 0.05,min * 0.95,min * 0.05);
        this.drawLine(ctx,min * 0.95,min * 0.05,min * 0.95,min * 0.95);
        this.drawLine(ctx,min * 0.95,min * 0.95,min * 0.05,min * 0.95);
        this.drawLine(ctx,min * 0.05,min * 0.95,min * 0.05,min * 0.05);

        this.drawLine(ctx,min * 0.05, min * 0.05,min / 2,min * 0.3);
        this.drawLine(ctx,min / 2,min * 0.3,min * 0.95,min * 0.05);

        this.drawLine(ctx,min * 0.3,min * 0.8,min * 0.3,min * 0.7);
        this.drawLine(ctx,min * 0.3,min * 0.7,min * 0.7,min * 0.7);
        this.drawLine(ctx,min * 0.7,min * 0.7,min * 0.7,min * 0.6);

        ctx.stroke();
    }
    draw3206 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.drawLine(ctx,min * 0.2, min * 0.2,min * 0.8,min * 0.2);
        this.drawLine(ctx,min * 0.8,min * 0.2,min * 0.8,min * 0.8);
        this.drawLine(ctx,min * 0.8,min * 0.8,min * 0.2,min * 0.8);
        this.drawLine(ctx,min * 0.2,min * 0.8,min * 0.2,min * 0.2);

        this.drawLine(ctx,min / 2,min * 0.02,min  / 2,min * 0.98);
        this.drawLine(ctx,min * 0.02,min / 2,min  * 0.98,min / 2);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3207 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.drawLine(ctx,min * 0.06,min * 0.3,min * 0.94,min * 0.3);
        this.drawLine(ctx,min * 0.94,min * 0.3,min * 0.94,min * 0.7);
        this.drawLine(ctx,min * 0.94,min * 0.7,min * 0.06,min * 0.7);
        this.drawLine(ctx,min * 0.06,min * 0.7,min * 0.06,min * 0.3);

        this.drawLine(ctx,min / 2,min * 0.06,min / 2,min * 0.3);
        this.drawLine(ctx,min / 2,min * 0.7,min / 2,min * 0.94);

        ctx.fillRect(min * 0.06,min * 0.3,min * 0.2,min * 0.4);
        ctx.stroke();
    }
    draw3208 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.drawLine(ctx,min * 0.06,min * 0.3,min * 0.94,min * 0.3);
        this.drawLine(ctx,min * 0.94,min * 0.3,min * 0.94,min * 0.7);
        this.drawLine(ctx,min * 0.94,min * 0.7,min * 0.06,min * 0.7);
        this.drawLine(ctx,min * 0.06,min * 0.7,min * 0.06,min * 0.3);

        this.drawLine(ctx,min / 2,min * 0.06,min / 2,min * 0.3);
        this.drawLine(ctx,min / 2,min * 0.7,min / 2,min * 0.94);

        this.drawLine(ctx,min * 0.06,min * 0.3,min * 0.2,min * 0.7);
        this.drawLine(ctx,min * 0.2,min * 0.3,min * 0.06,min * 0.7);
        this.drawLine(ctx,min * 0.2,min * 0.3,min * 0.2,min * 0.7);



        ctx.stroke();
    }
    draw3209 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.drawLine(ctx,min * 0.06,min * 0.3,min * 0.94,min * 0.3);
        this.drawLine(ctx,min * 0.94,min * 0.3,min * 0.94,min * 0.7);
        this.drawLine(ctx,min * 0.94,min * 0.7,min * 0.06,min * 0.7);
        this.drawLine(ctx,min * 0.06,min * 0.7,min * 0.06,min * 0.3);

        this.drawLine(ctx,min / 1.5,min * 0.06,min / 1.5,min * 0.3);
        this.drawLine(ctx,min / 1.5,min * 0.7,min / 1.5,min * 0.94);

        // this.drawLine(ctx,min * 0.06,min * 0.3,min * 0.2,min * 0.7);
        // this.drawLine(ctx,min * 0.2,min * 0.3,min * 0.06,min * 0.7);
        // this.drawLine(ctx,min * 0.2,min * 0.3,min * 0.2,min * 0.7);

        ctx.fillRect(min * 0.03,min * 0.3,min * 0.2,min * 0.4);

        this.drawLine(ctx,min * 0.3,min * 0.3,min * 0.44,min * 0.7);
        this.drawLine(ctx,min * 0.44,min * 0.3,min * 0.3,min * 0.7);
        this.drawLine(ctx,min * 0.44,min * 0.3,min * 0.44,min * 0.7);
        this.drawLine(ctx,min * 0.3,min * 0.3,min * 0.3,min * 0.7);


        ctx.stroke();
    }
    draw3210 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.drawLine(ctx,min * 0.06,min * 0.3,min * 0.94,min * 0.3);
        this.drawLine(ctx,min * 0.94,min * 0.3,min * 0.94,min * 0.7);
        this.drawLine(ctx,min * 0.94,min * 0.7,min * 0.06,min * 0.7);
        this.drawLine(ctx,min * 0.06,min * 0.7,min * 0.06,min * 0.3);

        this.drawLine(ctx,min / 2,min * 0.06,min / 2,min * 0.3);
        this.drawLine(ctx,min / 2,min * 0.7,min / 2,min * 0.94);


        this.drawLine(ctx,min * 0.2,min * 0.3,min * 0.2,min * 0.7);
        this.drawLine(ctx,min * 0.2,min * 0.5,min * 0.06,min * 0.5);


        ctx.stroke();
    }
    draw3211 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.drawLine(ctx,min * 0.06,min * 0.3,min * 0.94,min * 0.3);
        this.drawLine(ctx,min * 0.94,min * 0.3,min * 0.94,min * 0.7);
        this.drawLine(ctx,min * 0.94,min * 0.7,min * 0.06,min * 0.7);
        this.drawLine(ctx,min * 0.06,min * 0.7,min * 0.06,min * 0.3);

        this.drawLine(ctx,min / 2,min * 0.06,min / 2,min * 0.3);
        this.drawLine(ctx,min / 2,min * 0.7,min / 2,min * 0.94);

        ctx.fillRect(min * 0.06,min * 0.3,min * 0.88,min * 0.1);
        ctx.fillRect(min * 0.06,min * 0.6,min * 0.88,min * 0.1);

        ctx.stroke();
    }
    draw3212 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.drawLine(ctx,min * 0.06,min * 0.4,min * 0.94,min * 0.4);
        this.drawLine(ctx,min * 0.94,min * 0.4,min * 0.94,min * 0.6);
        this.drawLine(ctx,min * 0.94,min * 0.6,min * 0.06,min * 0.6);
        this.drawLine(ctx,min * 0.06,min * 0.6,min * 0.06,min * 0.4);
        this.drawLine(ctx,min / 2,min * 0.4,min / 2,min * 0.6);

        this.drawLine(ctx,min / 4,min * 0.2,min / 4,min * 0.4);
        this.drawLine(ctx,min / 4,min * 0.6,min / 4,min * 0.8);

        this.drawLine(ctx,min / 2 + min / 4,min * 0.2,min / 2 + min / 4,min * 0.4);
        this.drawLine(ctx,min / 2 + min / 4,min * 0.6,min / 2 + min / 4,min * 0.8);


        ctx.stroke();
    }
    draw3213 (ctx) {
         //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.drawLine(ctx,min * 0.06,min * 0.3,min * 0.94,min * 0.3);
        this.drawLine(ctx,min * 0.94,min * 0.3,min * 0.94,min * 0.7);
        this.drawLine(ctx,min * 0.94,min * 0.7,min * 0.06,min * 0.7);
        this.drawLine(ctx,min * 0.06,min * 0.7,min * 0.06,min * 0.3);

        this.drawLine(ctx,min / 1.6,min * 0.06,min / 1.6,min * 0.3);
        this.drawLine(ctx,min / 1.6,min * 0.7,min / 1.6,min * 0.94);

        this.drawLine(ctx,min * 0.3,min * 0.3,min * 0.3,min * 0.7);
        this.drawLine(ctx,min * 0.06,min * 0.5,min * 0.3,min * 0.7);
        this.drawLine(ctx,min * 0.06,min * 0.5,min * 0.3,min * 0.3);
        ctx.stroke();
    }
    draw3214 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.drawLine(ctx,min * 0.06,min * 0.3,min * 0.94,min * 0.3);
        this.drawLine(ctx,min * 0.94,min * 0.3,min * 0.94,min * 0.7);
        this.drawLine(ctx,min * 0.94,min * 0.7,min * 0.06,min * 0.7);
        this.drawLine(ctx,min * 0.06,min * 0.7,min * 0.06,min * 0.3);

        this.drawLine(ctx,min / 2,min * 0.02,min / 2,min * 0.3);
        this.drawLine(ctx,min / 2,min * 0.7,min / 2,min * 0.98);

        ctx.fillStyle = this.switchColor[0];
        ctx.fillRect(min * 0.06,min * 0.3,min * 0.2,min * 0.4);
        ctx.fillStyle = this.switchColor[1];
        ctx.fillRect(min * 0.1,min * 0.45,min * 0.06,min * 0.15);
        ctx.stroke();
    }
    draw3215 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        // 方框
        this.drawLine(ctx,min * 0.35,0,min * 0.35,min * 0.3);
        this.drawLine(ctx,min * 0.65,0,min * 0.65,min * 0.3);
        this.drawLine(ctx,min * 0.35,min * 0.3,min * 0.6,min * 0.3);
        // 开关
        this.drawLine(ctx,min * 0.52,min * 0.266,min * 0.65,min * 0.6);
        this.drawLine(ctx,min * 0.65,min * 0.6,min * 0.65,min * 0.9888);
        ctx.stroke();
    }
    draw3216 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        for (var i = 0; i < 4; i++) {
            this.drawLine(ctx,min * 0.06 + i * min / 3.6,min * 0.06,min * 0.06 + i * min / 3.6,min * 0.4);
        }
        this.drawLine(ctx,min * 0.06 + 1 * min / 3.6,min * 0.66,min * 0.06 + 1 * min / 3.6,min * 0.98);
        this.drawLine(ctx,min * 0.06 + 1 * min / 3.6,min * 0.66,min * 0.06,min * 0.46);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3217 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        this.drawLine(ctx,min / 2,min * 0.02,min / 2,min * 0.32);
        this.drawLine(ctx,min / 2,min * 0.65,min / 2,min * 0.98);
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx,min / 2,min * 0.65,min * 0.35,min *  0.32);
        ctx.font=`${min * 0.18}px Arial`;
        ctx.fillText("θ",min / 1.6,min / 2);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3218 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        this.drawLine(ctx,min / 2.5,min * 0.02,min / 2.5,min * 0.32);
        this.drawLine(ctx,min / 2.5,min * 0.65,min / 2.5,min * 0.98);
        this.drawLine(ctx,min / 2.5,min * 0.32,min / 1.6,min * 0.32);
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx,min / 2.5,min * 0.65,min / 1.7,min *  0.28);
        ctx.font=`${min * 0.18}px Arial`;
        ctx.fillText("θ",min / 1.6,min / 2);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3219 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        this.drawLine(ctx,min / 1.6,min * 0.02,min / 1.6,min * 0.32);
        this.drawLine(ctx,min / 1.6,min * 0.65,min / 1.6,min * 0.98);
        this.drawLine(ctx,min / 1.6,min * 0.32,min / 1.2,min * 0.32);
        this.drawLine(ctx,min / 1.6,min * 0.65,min / 1.23,min *  0.25);
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx,min / 1.44,min  / 2.2,min / 2,min / 2.2);
        this.drawLine(ctx,min / 2,min / 2.2,min / 2,min * 0.32);
        this.drawLine(ctx,min / 2,min * 0.32,min / 2.58,min * 0.32);
        this.drawLine(ctx,min / 2.58,min * 0.32,min / 2.58,min / 2.2);
        this.drawLine(ctx,min / 2.58,min / 2.2,min / 4,min / 2.2);
        ctx.stroke(); 
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3220 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        this.drawLine(ctx,min * 0.2,min * 0.06,min * 0.2,min * 0.4);
        this.drawLine(ctx,min * 0.12,min *  0.4,min * 0.28,min * 0.4);
        this.drawLine(ctx,min * 0.8,min * 0.06,min * 0.8,min * 0.4);
        this.drawLine(ctx,min * 0.72,min *  0.4,min * 0.88,min * 0.4);
        this.drawLine(ctx,min / 2,min *  0.4,min / 2,min *0.98);
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        ctx.beginPath();
        ctx.fillStyle = this.switchColor[1];
        ctx.arc(min / 2,min *  0.7,min * 0.03,0,2*Math.PI);
        ctx.fill();
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3221 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        // 两条直线
        this.drawLine(ctx,min * 0.65,min * 0.01,min * 0.65,min * 0.35);
        // 第三条直线
        this.drawLine(ctx,min * 0.52,min * 0.35,min * 0.65,min * 0.58);
        this.drawLine(ctx,min * 0.65,min * 0.58,min * 0.65,min * 0.98);
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        ctx.setLineDash([3, 3]);
        this.drawLine(ctx,min / 1.7,min  / 2,min / 3,min  / 2);
        ctx.stroke();
        ctx.beginPath();
        ctx.setLineDash([]);
        this.drawLine(ctx,min / 3,min  / 1.8,min / 3,min  / 2.3);

        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3222 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        // 两条直线
        this.drawLine(ctx,min * 0.65,min * 0.01,min * 0.65,min * 0.35);
        // 第三条直线
        this.drawLine(ctx,min * 0.52,min * 0.35,min * 0.65,min * 0.58);
        this.drawLine(ctx,min * 0.65,min * 0.58,min * 0.65,min * 0.98);
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        ctx.setLineDash([3, 3]);
        this.drawLine(ctx,min / 1.7,min  / 2,min / 3,min  / 2);
        ctx.stroke();
        ctx.beginPath();
        ctx.setLineDash([]);
        this.drawLine(ctx,min / 3,min  / 1.8,min / 3,min  / 2.3);
        this.drawLine(ctx,min / 3,min  / 2.3,min / 2.6,min  / 2.3);

        this.drawLine(ctx,min / 3,min  / 1.8,min / 2.6,min  / 1.8);


        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3223 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        // 两条直线
        this.drawLine(ctx,min * 0.65,min * 0.01,min * 0.65,min * 0.35);
        // 第三条直线
        this.drawLine(ctx,min * 0.52,min * 0.35,min * 0.65,min * 0.58);
        this.drawLine(ctx,min * 0.65,min * 0.58,min * 0.65,min * 0.98);
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        ctx.setLineDash([3, 3]);
        this.drawLine(ctx,min / 1.7,min  / 2,min / 3,min  / 2);
        ctx.stroke();
        ctx.beginPath();
        ctx.setLineDash([]);
        this.drawLine(ctx,min / 3,min  / 1.8,min / 3,min  / 2.3);
        this.drawLine(ctx,min / 3,min  / 2.3,min / 3.5,min  / 2.3);

        this.drawLine(ctx,min / 3,min  / 1.8,min / 3.5,min  / 1.8);


        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3224 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        // 两条直线
        this.drawLine(ctx,min * 0.65,min * 0.01,min * 0.65,min * 0.35);
        // 第三条直线
        this.drawLine(ctx,min * 0.52,min * 0.35,min * 0.65,min * 0.58);
        this.drawLine(ctx,min * 0.65,min * 0.58,min * 0.65,min * 0.98);
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        ctx.setLineDash([3, 3]);
        this.drawLine(ctx,min / 1.7,min  / 2,min / 3,min  / 2);
        ctx.stroke();
        ctx.beginPath();
        ctx.setLineDash([]);
        this.drawLine(ctx,min / 3,min  / 1.8,min / 3,min  / 2.3);
        this.drawLine(ctx,min / 3,min  / 2.3,min / 2.6,min  / 2.3);
        this.drawLine(ctx,min / 3,min  / 1.8,min / 3.5,min  / 1.8);


        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3225 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        // 两条直线
        this.drawLine(ctx,min * 0.85,min * 0.01,min * 0.85,min * 0.35);
        // 第三条直线
        this.drawLine(ctx,min * 0.85,min * 0.58,min * 0.85,min * 0.98);
        this.drawLine(ctx,min * 0.68,min * 0.35,min * 0.85,min * 0.58);

        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        ctx.setLineDash([3, 3]);
        this.drawLine(ctx,min / 1.32,min  / 2,min / 4.5,min  / 2);
        ctx.stroke();
        ctx.beginPath();
        ctx.setLineDash([]);
        this.drawLine(ctx,min / 4.5,min  / 1.8,min / 4.5,min  / 2.3);
        this.drawLine(ctx,min / 4.5,min  / 2.3,min / 3.8,min  / 2.3);
        this.drawLine(ctx,min / 4.5,min  / 1.8,min / 3.8,min  / 1.8);
        ctx.stroke();
        // 画圆
        ctx.beginPath();
        ctx.arc(min / 1.9,min / 2.6,min * 0.09,0,2*Math.PI);
        this.drawLine(ctx,min / 2.1,min / 2.6,min / 1.7, min / 2.6);
        this.drawLine(ctx,min / 1.7, min / 2.6,min / 1.8, min / 2.8);
        this.drawLine(ctx,min / 1.7, min / 2.6,min / 1.8, min / 2.4);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3226 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        // 两条直线
        this.drawLine(ctx,min * 0.35,min * 0.08,min * 0.35,min * 0.35);
        this.drawLine(ctx,min * 0.65,min * 0.08,min * 0.65,min * 0.35);
        // 第三条直线
        this.drawLine(ctx,min * 0.5,min * 0.3,min * 0.5,min * 0.98);
        // 小矩形
        ctx.fillStyle = this.switchColor[1];;
        ctx.fillRect(min * 0.5 - min * 0.08 / 2,min * 0.7 - min * 0.08,min * 0.08,min * 0.08);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3227 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        for(let i = 0; i< 6; i++){
            this.drawLine(ctx,(i * 1) * 0.16 * min + min * 0.18,min * 0.2,(i * 1) * 0.16 * min +  min * 0.18,min * 0.4);
        }
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx,min * 0.18,min * 0.5,min * 0.18,min * 0.7);
        this.drawLine(ctx,min * 0.06,min * 0.7,min * 0.98,min * 0.7);
        this.drawLine(ctx,min * 0.06,min * 0.7,min * 0.06,min * 0.9);
        this.drawLine(ctx,min * 0.19,min * 0.7,min * 0.19,min * 0.85);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3228 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        this.drawLine(ctx,min * 0.56,min * 0.02, min * 0.56,min * 0.28);
        this.drawLine(ctx,min * 0.5,min *  0.28, min * 0.62,min * 0.28);
        ctx.stroke();
        ctx.beginPath();
        ctx.fillStyle = this.switchColor[0];
        ctx.arc(min * 0.56,min *  0.345,min * 0.05,0,2*Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx,min * 0.56,min *  0.68, min * 0.56,min * 0.99);
        this.drawLine(ctx,min * 0.56,min *  0.68, min * 0.38,min * 0.345);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3229 (ctx) {
         //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        this.drawLine(ctx,min * 0.56,min * 0.02, min * 0.56,min * 0.28);
        this.drawLine(ctx,min * 0.5,min *  0.28, min * 0.62,min * 0.28);
        ctx.stroke();
        ctx.beginPath();
        ctx.fillStyle = this.switchColor[0];
        ctx.arc(min * 0.56,min *  0.345,min * 0.05,0,2*Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx,min * 0.56,min *  0.68, min * 0.56,min * 0.99);
        this.drawLine(ctx,min * 0.56,min *  0.68, min * 0.38,min * 0.345);
        ctx.stroke();
        ctx.beginPath();
        ctx.fillStyle = this.switchColor[1];
        this.drawLine(ctx,min * 0.45,min *  0.48, min * 0.39,min * 0.54);
        ctx.lineTo(min * 0.43,min * 0.60);
        ctx.lineTo(min * 0.51,min * 0.57);
        ctx.fill();
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3230 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        this.drawLine(ctx,min * 0.05, min * 0.05,min * 0.95,min * 0.05);
        this.drawLine(ctx,min * 0.95,min * 0.05,min * 0.95,min * 0.95);
        this.drawLine(ctx,min * 0.95,min * 0.95,min * 0.05,min * 0.95);
        this.drawLine(ctx,min * 0.05,min * 0.95,min * 0.05,min * 0.05);

        this.drawLine(ctx,min * 0.05, min * 0.05,min / 2,min * 0.3);
        this.drawLine(ctx,min / 2,min * 0.3,min * 0.95,min * 0.05);
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx,min * 0.5,min * 0.6,min * 0.68,min * 0.85);
        this.drawLine(ctx,min * 0.5,min * 0.6,min * 0.32,min * 0.85);
        this.drawLine(ctx,min * 0.32,min * 0.85,min * 0.68,min * 0.85);

        this.drawLine(ctx,min * 0.5,min * 0.6,min * 0.5,min * 0.75);
        this.drawLine(ctx,min * 0.32,min * 0.85,min * 0.5,min * 0.75);
        this.drawLine(ctx,min * 0.68,min * 0.85,min * 0.5,min * 0.75);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3231 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.strokeColor = this.switchColor[0];
        this.drawLine(ctx,min * 0.06,min * 0.3,min * 0.94,min * 0.3);
        this.drawLine(ctx,min * 0.94,min * 0.3,min * 0.94,min * 0.7);
        this.drawLine(ctx,min * 0.94,min * 0.7,min * 0.06,min * 0.7);
        this.drawLine(ctx,min * 0.06,min * 0.7,min * 0.06,min * 0.3);

        this.drawLine(ctx,min * 0.66,min * 0.06,min  * 0.66,min * 0.3);
        this.drawLine(ctx,min  * 0.66,min * 0.7,min  * 0.66,min * 0.94);

        this.drawLine(ctx,min * 0.4,min * 0.3,min * 0.4,min * 0.7);
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle=this.switchColor[1];
        ctx.moveTo(min*0.1,min*0.5);
        ctx.bezierCurveTo(min*0.2,min*0.3,min*0.3,min*0.65,min*0.35,min*0.45);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3232 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.strokeColor = this.switchColor[0];
        this.drawLine(ctx,min * 0.06,min * 0.3,min * 0.58,min * 0.3);
        this.drawLine(ctx,min * 0.58,min * 0.3,min * 0.58,min * 0.7);
        this.drawLine(ctx,min * 0.58,min * 0.7,min * 0.06,min * 0.7);
        this.drawLine(ctx,min * 0.06,min * 0.7,min * 0.06,min * 0.3);

        this.drawLine(ctx,min * 0.32,min * 0.3,min * 0.32,min * 0.1);
        this.drawLine(ctx,min * 0.32,min * 0.7,min * 0.32,min * 0.9);

        this.drawLine(ctx,min * 0.58,min * 0.5,min * 0.98,min * 0.5);
        ctx.stroke();

        ctx.beginPath();
        ctx.strokeStyle=this.switchColor[1];
        ctx.moveTo(min * 0.7,min * 0.35);
        ctx.bezierCurveTo(min*0.88,min*0.48,min*0.62,min*0.56,min*0.78,min*0.65);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3233 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.strokeColor = this.switchColor[0];
        this.drawLine(ctx,min * 0.6,min * 0.02,min * 0.6,min * 0.3);
        this.drawLine(ctx,min * 0.6,min * 0.68,min * 0.6,min * 0.998);
        this.drawLine(ctx,min * 0.6,min * 0.68,min * 0.43,min * 0.28);
        ctx.stroke();

        ctx.beginPath();
        ctx.strokeStyle=this.switchColor[1];
        ctx.moveTo(min * 0.6,min * 0.3); 
        ctx.quadraticCurveTo(min * 0.5,min * 0.2, min * 0.6,min * 0.15);
        // ctx.moveTo(min * 0.7,min * 0.35);
        // ctx.bezierCurveTo(min*0.88,min*0.48,min*0.62,min*0.56,min*0.78,min*0.65);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3234 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.strokeColor = this.switchColor[0];
        this.drawLine(ctx,min * 0.6,min * 0.02,min * 0.6,min * 0.3);
        this.drawLine(ctx,min * 0.6,min * 0.68,min * 0.6,min * 0.998);
        this.drawLine(ctx,min * 0.6,min * 0.68,min * 0.43,min * 0.28);


        this.drawLine(ctx,min * 0.505,min * 0.46,min * 0.43,min * 0.5);
        ctx.lineTo(min * 0.46,min * 0.56);
        ctx.lineTo(min * 0.53,min * 0.52);
        ctx.fill();
        ctx.stroke();

        ctx.beginPath();
        ctx.strokeStyle=this.switchColor[1];
        ctx.moveTo(min * 0.6,min * 0.3); 
        ctx.quadraticCurveTo(min * 0.5,min * 0.2, min * 0.6,min * 0.15);
        // ctx.moveTo(min * 0.7,min * 0.35);
        // ctx.bezierCurveTo(min*0.88,min*0.48,min*0.62,min*0.56,min*0.78,min*0.65);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3235 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.strokeColor = this.switchColor[0];
        this.drawLine(ctx,min * 0.4,min * 0.02,min * 0.4,min * 0.3);
        this.drawLine(ctx,min * 0.4,min * 0.3,min * 0.65,min * 0.3);

        this.drawLine(ctx,min * 0.4,min * 0.68,min * 0.4,min * 0.998);
        this.drawLine(ctx,min * 0.4,min * 0.68,min * 0.60,min * 0.25);
        ctx.stroke();

        ctx.beginPath();
        ctx.strokeStyle=this.switchColor[1];
        ctx.moveTo(min * 0.4,min * 0.3); 
        ctx.quadraticCurveTo(min * 0.5,min * 0.2, min * 0.4,min * 0.15);
        // ctx.moveTo(min * 0.7,min * 0.35);
        // ctx.bezierCurveTo(min*0.88,min*0.48,min*0.62,min*0.56,min*0.78,min*0.65);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3236 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.strokeColor = this.switchColor[0];
        this.drawLine(ctx,min * 0.7,min * 0.02,min * 0.7,min * 0.3);
        this.drawLine(ctx,min * 0.7,min * 0.6,min * 0.7,min * 0.980);
        this.drawLine(ctx,min * 0.7,min * 0.6,min * 0.5,min * 0.3);

        this.drawLine(ctx,min * 0.28,min * 0.45,min * 0.59,min * 0.45);
        this.drawLine(ctx,min * 0.28,min * 0.5,min * 0.62,min * 0.5);
        // this.drawLine(ctx,min * 0.7,min * 0.6,min * 0.5,min * 0.3);

        ctx.stroke();

        ctx.beginPath();
        ctx.strokeStyle=this.switchColor[1];
        ctx.closePath();
        ctx.stroke();
        ctx.arc(min*0.17,min*0.48,min*0.1,Math.PI * 1.5,Math.PI / 2,false);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3237 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        // 方框
        this.drawLine(ctx,min * 0.35,0,min * 0.35,min * 0.3);
        this.drawLine(ctx,min * 0.65,0,min * 0.65,min * 0.3);
        this.drawLine(ctx,min * 0.35,min * 0.3,min * 0.6,min * 0.3);
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        // 开关
        this.drawLine(ctx,min * 0.52,min * 0.23,min * 0.65,min * 0.6);
        this.drawLine(ctx,min * 0.65,min * 0.6,min * 0.65,min * 0.9888);
        this.drawLine(ctx,min * 0.48,min * 0.23,min * 0.54,min * 0.20);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3238 (ctx) {
         //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.strokeColor = this.switchColor[0];
        this.drawLine(ctx,min * 0.7,min * 0.02,min * 0.7,min * 0.3);
        this.drawLine(ctx,min * 0.7,min * 0.6,min * 0.7,min * 0.980);
        this.drawLine(ctx,min * 0.7,min * 0.6,min * 0.5,min * 0.3);

        this.drawLine(ctx,min * 0.28,min * 0.45,min * 0.59,min * 0.45);
        this.drawLine(ctx,min * 0.28,min * 0.5,min * 0.62,min * 0.5);
        // this.drawLine(ctx,min * 0.7,min * 0.6,min * 0.5,min * 0.3);

        ctx.stroke();

        ctx.beginPath();
        ctx.strokeStyle=this.switchColor[1];
        ctx.closePath();
        ctx.stroke();
        ctx.arc(min*0.38,min*0.48,min*0.1,Math.PI / 2,Math.PI * 1.5,false);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3239 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        this.drawLine(ctx,min * 0.05, min * 0.05,min * 0.95,min * 0.05);
        this.drawLine(ctx,min * 0.95,min * 0.05,min * 0.95,min * 0.95);
        this.drawLine(ctx,min * 0.95,min * 0.95,min * 0.05,min * 0.95);
        this.drawLine(ctx,min * 0.05,min * 0.95,min * 0.05,min * 0.05);

        this.drawLine(ctx,min * 0.05, min * 0.05,min / 2,min * 0.3);
        this.drawLine(ctx,min / 2,min * 0.3,min * 0.95,min * 0.05);

        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        ctx.arc(min*0.4,min*0.6,min*0.14,0,2*Math.PI);
        ctx.moveTo(min*0.4,min*0.74);
        ctx.quadraticCurveTo(min*0.5,min*0.8, min*0.7,min*0.6);
        this.drawLine(ctx,min*0.7,min*0.6, min*0.9,min*0.6);
        this.drawLine(ctx,min * 0.1,min*0.6, min*0.26,min*0.6);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3240 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.strokeColor = this.switchColor[0];
        this.drawLine(ctx,min * 0.5,min * 0.02,min * 0.5,min * 0.3);
        this.drawLine(ctx,min * 0.5,min * 0.3,min * 0.72,min * 0.3);

        this.drawLine(ctx,min * 0.5,min * 0.6,min * 0.5,min * 0.980);
        this.drawLine(ctx,min * 0.5,min * 0.6,min * 0.68,min * 0.25);

        this.drawLine(ctx,min * 0.28,min * 0.45,min * 0.59,min * 0.45);
        this.drawLine(ctx,min * 0.28,min * 0.5,min * 0.56,min * 0.5);
        // this.drawLine(ctx,min * 0.5,min * 0.6,min * 0.5,min * 0.3);

        ctx.stroke();

        ctx.beginPath();
        ctx.strokeStyle=this.switchColor[1];
        ctx.closePath();
        ctx.stroke();
        ctx.arc(min*0.38,min*0.48,min*0.1,Math.PI / 2,Math.PI * 1.5,false);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3241 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.strokeColor = this.switchColor[0];
        this.drawLine(ctx,min * 0.5,min * 0.02,min * 0.5,min * 0.3);
        this.drawLine(ctx,min * 0.5,min * 0.3,min * 0.72,min * 0.3);

        this.drawLine(ctx,min * 0.5,min * 0.6,min * 0.5,min * 0.980);
        this.drawLine(ctx,min * 0.5,min * 0.6,min * 0.68,min * 0.25);

        this.drawLine(ctx,min * 0.28,min * 0.45,min * 0.59,min * 0.45);
        this.drawLine(ctx,min * 0.28,min * 0.5,min * 0.56,min * 0.5);
        // this.drawLine(ctx,min * 0.5,min * 0.6,min * 0.5,min * 0.3);

        ctx.stroke();

        ctx.beginPath();
        ctx.strokeStyle=this.switchColor[1];
        ctx.closePath();
        ctx.stroke();
        ctx.arc(min*0.18,min*0.48,min*0.1,Math.PI * 1.5,Math.PI / 2,false);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3242 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.strokeColor = this.switchColor[0];
        this.drawLine(ctx,min * 0.5,min * 0.02,min * 0.5,min * 0.3);
        this.drawLine(ctx,min * 0.5,min * 0.3,min * 0.72,min * 0.3);

        this.drawLine(ctx,min * 0.5,min * 0.6,min * 0.5,min * 0.980);
        this.drawLine(ctx,min * 0.5,min * 0.6,min * 0.68,min * 0.25);

        this.drawLine(ctx,min * 0.28,min * 0.45,min * 0.59,min * 0.45);
        this.drawLine(ctx,min * 0.28,min * 0.5,min * 0.56,min * 0.5);

        ctx.stroke();

        ctx.beginPath();
        ctx.strokeStyle=this.switchColor[1];
        ctx.stroke();
        ctx.arc(min*0.18,min*0.48,min*0.1,Math.PI * 1.5,Math.PI / 2,false);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(min*0.38,min*0.48,min*0.1,Math.PI / 2,Math.PI * 1.5,false);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3243 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.strokeColor = this.switchColor[0];
        this.drawLine(ctx,min * 0.5,min * 0.02,min * 0.5,min * 0.3);
        this.drawLine(ctx,min * 0.5,min * 0.6,min * 0.5,min * 0.98);
        this.drawLine(ctx,min * 0.5,min * 0.6,min * 0.35,min * 0.3);

        this.drawLine(ctx,min * 0.5,min * 0.6,min * 0.35,min * 0.52);
        this.drawLine(ctx,min * 0.35,min * 0.52,min * 0.43,min * 0.47);
        ctx.stroke();

        ctx.beginPath();
        ctx.strokeStyle=this.switchColor[1];
        
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3244 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.strokeColor = this.switchColor[0];
        this.drawLine(ctx,min * 0.5,min * 0.02,min * 0.5,min * 0.3);
        this.drawLine(ctx,min * 0.5,min * 0.3,min * 0.72,min * 0.3);
        this.drawLine(ctx,min * 0.5,min * 0.6,min * 0.5,min * 0.98);
        this.drawLine(ctx,min * 0.5,min * 0.6,min * 0.68,min * 0.26);

        this.drawLine(ctx,min * 0.53,min * 0.52,min * 0.53,min * 0.4);
        this.drawLine(ctx,min * 0.53,min * 0.4,min * 0.6,min * 0.4);


        ctx.stroke();

        ctx.beginPath();
        ctx.strokeStyle=this.switchColor[1];
        
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3245 (ctx) {
         //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.strokeColor = this.switchColor[0];
        this.drawLine(ctx,min * 0.6,min * 0.02,min * 0.6,min * 0.3);
        this.drawLine(ctx,min * 0.6,min * 0.3,min * 0.82,min * 0.3);
        this.drawLine(ctx,min * 0.6,min * 0.6,min * 0.6,min * 0.98);
        this.drawLine(ctx,min * 0.6,min * 0.6,min * 0.78,min * 0.26);

        this.drawLine(ctx,min * 0.65,min * 0.5,min * 0.65,min * 0.38);
        this.drawLine(ctx,min * 0.65,min * 0.38,min * 0.71,min * 0.38);


        ctx.stroke();

        ctx.beginPath();
        ctx.strokeStyle=this.switchColor[1];
        ctx.arc(min / 2.2,min / 2.6,min * 0.09,0,2*Math.PI);
        this.drawLine(ctx,min / 2.6,min / 2.6,min / 1.9, min / 2.6);
        this.drawLine(ctx,min / 1.9, min / 2.6,min / 2, min / 2.8);
        this.drawLine(ctx,min / 1.9, min / 2.6,min / 2, min / 2.4);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3246 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        this.drawLine(ctx,min * 0.15, min * 0.4,min * 0.85,min * 0.4);
        this.drawLine(ctx,min * 0.85,min * 0.4,min * 0.85,min * 0.95);
        this.drawLine(ctx,min * 0.85,min * 0.95,min * 0.15,min * 0.95);
        this.drawLine(ctx,min * 0.15,min * 0.95,min * 0.15, min * 0.4);

        this.drawLine(ctx,min * 0.15, min * 0.4,min * 0.5,min * 0.55);
        this.drawLine(ctx,min * 0.5,min * 0.55,min * 0.85,min * 0.4);
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[1];
        this.drawLine(ctx, min*0.3, min*0.6, min*0.8, min*0.15);
        ctx.stroke();;
        ctx.beginPath();
        this.drawLine(ctx, min*0.8, min*0.15, min*0.65, min*0.2);
        ctx.lineTo(min*0.8, min*0.25); 
        ctx.fill(); 
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3247 (ctx) {
         //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        // 两条直线
        this.drawLine(ctx,min * 0.35,min * 0.01,min * 0.35,min * 0.15);
        this.drawLine(ctx,min * 0.35,min * 0.15,min * 0.75,min * 0.15);
        this.drawLine(ctx,min * 0.65,min * 0.01,min * 0.65,min * 0.35);
        // 第三条直线
        // this.drawLine(ctx,min * 0.65,min * 0.58,min * 0.65,min * 0.58);
        this.drawLine(ctx,min * 0.52,min * 0.266,min * 0.65,min * 0.58);

        this.drawLine(ctx,min * 0.65,min * 0.58,min * 0.65,min * 0.98);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3248 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        // 两条直线
        // this.drawLine(ctx,min * 0.35,min * 0.01,min * 0.35,min * 0.15);
        // this.drawLine(ctx,min * 0.35,min * 0.15,min * 0.75,min * 0.15);
        this.drawLine(ctx,min * 0.4,min * 0.266,min * 0.5,min * 0.266);
        this.drawLine(ctx,min * 0.5,min * 0.266,min * 0.5,min * 0.04);

        this.drawLine(ctx,min * 0.5,min * 0.35,min * 0.75,min * 0.35);
        this.drawLine(ctx,min * 0.75,min * 0.35,min * 0.75,min * 0.04);

       
        this.drawLine(ctx,min * 0.36,min * 0.266,min * 0.5,min * 0.58);
        this.drawLine(ctx,min * 0.5,min * 0.58,min * 0.5,min * 0.98);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3249 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        // 两条直线

        this.drawLine(ctx,min * 0.3,min * 0.03,min * 0.3,min * 0.45);
        this.drawLine(ctx,min * 0.3,min * 0.45,min * 0.85,min * 0.45);

        this.drawLine(ctx,min * 0.6,min * 0.03,min * 0.6,min * 0.3);
        this.drawLine(ctx,min * 0.6,min * 0.3,min * 0.85,min * 0.3);

       
        this.drawLine(ctx,min * 0.6,min * 0.58,min * 0.8,min * 0.266);
        this.drawLine(ctx,min * 0.6,min * 0.58,min * 0.6,min * 0.98);
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3250 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        ctx.strokeStyle = this.switchColor[0];
        // 方框
        this.drawLine(ctx,min * 0.35,0,min * 0.35,min * 0.3);
        this.drawLine(ctx,min * 0.35,min * 0.3,min * 0.6,min * 0.3);

        this.drawLine(ctx,min * 0.35,min * 0.6,min * 0.35,min * 0.998);
        // 钩子
        this.drawLine(ctx,min * 0.35,min * 0.6,min * 0.55,min * 0.2);
        this.drawLine(ctx,min * 0.55,min * 0.2,min * 0.55,min * 0.2);
        this.drawLine(ctx,min * 0.55,min * 0.2,min * 0.6,min * 0.27);


        // 开关
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw3251 (ctx) {
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.lineWidth=this.lineWight;
        ctx.beginPath();
        this.drawLine(ctx,min * 0.05, min * 0.05,min * 0.95,min * 0.05);
        this.drawLine(ctx,min * 0.95,min * 0.05,min * 0.95,min * 0.95);
        this.drawLine(ctx,min * 0.95,min * 0.95,min * 0.05,min * 0.95);
        this.drawLine(ctx,min * 0.05,min * 0.95,min * 0.05,min * 0.05);

        this.drawLine(ctx,min * 0.05, min * 0.05,min / 2,min * 0.3);
        this.drawLine(ctx,min / 2,min * 0.3,min * 0.95,min * 0.05);


        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
    draw2014(ctx){
        //canvas高度和宽度
        var width = this.width;
        var height = this.height;
        //取宽度和高度较小的一个为绘制的canvas的大小（在内存中构造一个正方形的canvas，通过drawImage函数来完成拉伸和缩放）
        var min = width > height ? height : width;

        ctx.save();
        ctx.translate(this.cx+min/2,this.cy+min/2);
        ctx.rotate((Math.PI/180)*this.rotate);
        ctx.translate(-min/2,-min/2);

        /*-------------------------------实际绘制部分----------------------------------------*/
        ctx.strokeStyle=this.lineColer;
        ctx.lineWidth=this.lineWight;
        if(this.value){
            ctx.fillStyle=this.switchColor[0];
        }else{
            ctx.fillStyle=this.switchColor[1];  
        }
        ctx.beginPath();
        this.drawLine(ctx,min*0.05,min*0.5,min*0.3,min*0.5);
        
        this.drawLine(ctx,min*0.3,min*0.5,min*0.6,min*0.5);

        ctx.fillStyle=this.switchColor[1]; 
        ctx.arc(min*0.3,min*0.5,min*0.02,0,2*Math.PI);
        ctx.fill();

        this.drawLine(ctx,min*0.6,min*0.4,min*0.95,min*0.4);
        ctx.fillStyle=this.switchColor[1]; 
        ctx.arc(min*0.6,min*0.4,min*0.02,0,2*Math.PI);
        ctx.fill();

        this.drawLine(ctx,min*0.6,min*0.6,min*0.95,min*0.6);
        ctx.fillStyle=this.switchColor[1]; 
        ctx.arc(min*0.6,min*0.6,min*0.02,0,2*Math.PI);
        ctx.fill();
        ctx.stroke();
        /*-----------------------------------------------------------------------*/
        ctx.restore();
    }
}


// WEBPACK FOOTER //
// ./src/js/div/divUnit/fvPowerSwitch.js